/**
 * @file 简体中文话术
 * @author zhujialu
 */
define(function (require, exports) {
    'use strict'

    /**
     * =================================================
     * 用户角色
     * =================================================
     */

    exports.USER_ROLE_TEACHER = 'giáo viên'

    exports.USER_ROLE_STUDENT = 'sinh'

    exports.USER_ROLE_GUEST = 'du'

    exports.USER_ROLE_ASSISTANT = 'trợ'

    exports.USER_ROLE_SPECIAL_GUEST = 'khách đặc biệt'

    exports.USER_ASSISTANT_NUMBER = 'trợ giảng ${number}'

    /**
     * =================================================
     * 老师状态
     * =================================================
     */

    exports.TEACHER_UNKNOW = 'thầy giáo không vào lớp'

    exports.TEACHER_IN = 'thầy giáo đã vào lớp'

    exports.TEACHER_OUT = 'thầy giáo đã rời khỏi lớp'

    exports.TEACHER_AUDIO_ON = 'thầy giáo bật micro lên rồi.'

    exports.TEACHER_AUDIO_OFF = 'thầy giáo đã tắt microphone.'

    exports.TEACHER_VIDEO_ON = 'thầy giáo đã bật máy quay'

    exports.TEACHER_VIDEO_OFF = 'thầy giáo đã tắt máy quay.'

    /**
     * =================================================
     * 用户状态
     * =================================================
     */

    exports.USER_OUT = 'ta đã rời khỏi lớp'

    exports.USER_AUDIO_ON = 'micro đã bật'

    exports.USER_AUDIO_OFF = 'tắt điện thoại'

    exports.USER_VIDEO_ON = 'máy ảnh bật'

    exports.USER_VIDEO_OFF = 'camera tắt'

    /**
     * =================================================
     * 自己状态
     * =================================================
     */

    exports.SELF_AUDIO_ON = 'micro đã bật'

    exports.SELF_AUDIO_OFF = 'tắt điện thoại'

    exports.SELF_VIDEO_ON = 'máy ảnh bật'

    exports.SELF_VIDEO_OFF = 'camera tắt'

    /**
     * =================================================
     * 画质
     * =================================================
     */

    exports.VIDEO_QUALITY_LOW = 'trôi chảy'

    exports.VIDEO_QUALITY_MEDIUM = 'rõ'

    exports.VIDEO_QUALITY_HIGH = 'Định nghĩa cao'

    exports.VIDEO_QUALITY_SUPER = 'name'

    exports.VIDEO_QUALITY_720planguage = '720planguage'

    exports.VIDEO_QUALITY_1080p = '1080p'

    /**
     * =================================================
     * 百家云终端类型
     * =================================================
     */

    exports.END_TYPE_PC_BROWSER_BJY = 'trang web máy tính'

    exports.END_TYPE_PC_CLIENT_BJY = 'máy chủ pc'

    exports.END_TYPE_MAC_CLIENT_BJY = 'khách hàng mac'

    exports.END_TYPE_MOBILE_BROWSER_BJY = 'cấu hình mạngname'

    exports.END_TYPE_MOBILE_XIAOCHENGXU = 'công thức chat'

    exports.END_TYPE_MOBILE_APPLE_BJY = 'Ứng dụng apple'

    exports.END_TYPE_MOBILE_ANDROID_BJY = 'Ứng dụng android'

    exports.END_TYPE_MINI_PROGRAM_BJY = 'táo'

    exports.END_TYPE_WEBRTC_BJY = 'có thể ăn bột.'

    exports.END_TYPE_UNKNOWN_BJY = 'chưa'

    /**
     * =================================================
     * 音视频链路状态
     * =================================================
     */

    exports.AV_PLAY_STATUS_CONNECTING = 'xây dựng mối quan hệ với bên kia'

    exports.AV_PLAY_STATUS_FAIL = 'lỗi thiết lập kết nối'

    exports.AV_PLAY_STATUS_BUFFERING = 'dữ liệu đệm'

    /**
     * =================================================
     * 快捷键
     * =================================================
     */

    exports.SHORTCUT_EXIT_FULLSCREEN = 'Để thoát khỏi toàn bộ màn hình, ấn esc'

    /**
     * =================================================
     * 按钮
     * =================================================
     */

    exports.BUTTON_SUBMIT = 'xác định'

    exports.BUTTON_CLOSE = 'đóng'

    exports.BUTTON_CANCEL = 'hủy'

    exports.BUTTON_ACCEPT = 'đồng ý!'

    exports.BUTTON_REJECT = 'từ'

    exports.BUTTON_REFRESH = 'cập nhật'

    exports.BUTTON_TRY_REFRESH = 'cập nhật và thử lại'

    exports.BUTTON_CLOSE_ROOM = 'ngừng phát sóng'

    exports.BUTTON_REENTER = 'trở vào lớp'

    exports.BUTTON_LEAVE = 'thoát khỏi lớp học'

    exports.BUTTON_START_CLASS = 'tham gia lớp;lớp bắt đầu'

    exports.BUTTON_START_CLASS_FOR_SELL = 'bắt đầu hiện'

    exports.BUTTON_END_CLASS = 'lớp học chấm dứt'

    exports.BUTTON_END_CLASS_FOR_SELL = 'xóa'

    exports.BUTTON_LEAVE_CLASS_AND_REMOVE_ALL = 'bỏ học sinh ra.'

    exports.BUTTON_END_CLASS_AND_REMOVE_ALL = 'lớp học đã hết và học sinh đã bị loại'

    exports.BUTTON_STOP_RTMP_PUSH = 'không phát sóng'

    exports.BUTTON_PLAY_MEDIA = 'chơi'

    exports.BUTTON_RECORD_CLASS = 'ghi lưu lộ trình'

    exports.BUTTON_START_RECORD_CLASS = 'Đầu'

    exports.BUTTON_STOP_RECORD_CLASS = 'dừng ghi âm'

    exports.BUTTON_RESTART_RECORD_CLASS = 'tiếp'

    exports.BUTTON_RECORD_FULLSCREEN = 'máy ghi toàn màn hình'

    exports.BUTTON_RECORD_AREA = 'bản ghi âm học'

    exports.BUTTON_START_SCREEN_SHARE = 'chia màn hìnhname'

    exports.BUTTON_QUESTION_ANSWER = 'q*u. a'

    exports.BUTTON_EXAM = 'nghiên cứu kết cấu về xứng đôi'
    exports.BUTTON_END_EXAM = 'kết thúc khám nghiệm'

    exports.BUTTON_STOP_SCREEN_SHARE = 'cuối'

    exports.BUTTON_RECORD_SETTINGS = 'Đặt lộ trình ghi âm'

    exports.BUTTON_THIRD_PUSH = 'truyền mạnh'

    exports.BUTTON_FORBID_MIC = 'tạ'

    exports.BUTTON_CANCEL_FORBID_MIC = 'hủy lệnh cấm'

    exports.BUTTON_SURVEY = 'thử'

    exports.BUTTON_LOTTERY = 'may mắn kéo'

    exports.BUTTON_ANSWER = 'máy trả lời'

    exports.BUTTON_DEBUG = 'sửa'

    exports.BUTTON_TIMER = 'timer'

    exports.BUTTON_RED_PACKET = 'mưa phong bì đỏ'

    exports.BUTTON_ENTER_FULLSCREEN = 'toàn màn hình'

    exports.BUTTON_EXIT_FULLSCREEN = 'thoát màn hình đầy'

    exports.BUTTON_OPEN_CAMERA = 'chưa mở'

    exports.BUTTON_CLOSE_CAMERA = 'quay lại'

    exports.BUTTON_OPEN_MIC = 'chưa mở'

    exports.BUTTON_CLOSE_MIC = 'quay lại'

    exports.BUTTON_SPEAK_APPLY = 'giơ tay lên'

    exports.BUTTON_SPEAK_APPLY_CANCEL = 'hủy'

    exports.BUTTON_END_SPEAK = 'cuối'

    exports.BUTTON_MANAGE_DOCUMENT = 'lớp luyện của tôi'

    exports.BUTTON_ADD_DOCUMENT = 'thêm vào'

    exports.BUTTON_REMOVE_DOCUMENT = 'tháo'

    exports.BUTTON_DELETE_DOCUMENT = 'xóa'

    exports.BUTTON_SUBMIT_DOCUMENT = 'xác nhận chọn'

    exports.BUTTON_ADD_DOCUMENT_FORM_NETDESK = 'chọn cơ sở dữ liệu'

    exports.BUTTON_UPLOAD_DOCUMENT = 'các đệ tử'

    exports.BUTTON_SEND_MESSAGE = 'phát ra'

    exports.BUTTON_GIFT = 'giao thức uống'

    exports.BUTTON_EDIT_NOTICE = 'thông báo tổng hợp'

    exports.BUTTON_SAVE_NOTICE = 'lưu thông báo'

    exports.BUTTON_SWITCH_GIFT = 'Đổi tách'

    exports.BUTTON_SEND_GIFT_TO_TEACHER = 'vì sư phụ.'

    exports.BUTTON_FORBID_USER_SEND_MESSAGE = 'không ta chat'

    exports.BUTTON_UNFORBID_USER_SEND_MESSAGE = 'bỏ lệnh cấm vào ta'

    exports.BUTTON_SURVEY_ADD_OPTION = 'thêm các tùy chọn'

    exports.BUTTON_NEED = 'nhu'

    exports.BUTTON_NO_NEED = 'không'

    exports.BUTTON_REPLY_SUBMIT = 'xác nhận câu trả lời'

    exports.BUTTON_MINIMIZE = 'giảm'

    exports.BUTTON_HELP = 'tìm trợ giúp'

    exports.BUTTON_ASSISTANT_LINK = 'liên kết với giảng viên'

    exports.BUTTON_JOIN_USERLIST = 'danh sách tham dự'

    exports.BUTTON_ATTENTION_DETECTION = 'tập trung thử'

    exports.BUTTON_GEN_LINK = 'tạo liên kết'

    exports.BUTTON_COPY_LINK = 'rõ'

    exports.BUTTON_COPY_LINK_SUCC = 'thành công'

    exports.BUTTON_COMMENT = 'đánh'

    exports.BUTTON_DETECT = 'thử'

    exports.BUTTON_MORE = 'thêm'

    exports.BUTTON_NEXT_STEP = 'bước kế tiếp'

    exports.BUTTON_COMPLETE = 'hoàn'

    exports.BUTTON_COMMENT_SUBMIT = 'ghi chú'

    exports.BUTTOM_COMMENT_SEND = 'Đánh giá giáo viên'

    exports.BUTTON_COMMENT_CANCEL = 'tôi không bình luận.'

    exports.BUTTON_SHOW_LOGS = 'bung bản ghi ra'

    exports.BUTTON_HIDE_LOGS = 'cất khúc gỗ đi.'

    exports.BUTTON_RETURN = 'quay'

    exports.BUTTON_SERVER_ROUTE = 'dòng'

    exports.BUTTON_SERVER_SUGGEST = 'Đường ưa thích'

    exports.BUTTON_SERVER_BACKUP = 'Đường khác'

    exports.BUTTON_SWITCH_TO_ONLINE = 'rõ ràng'

    exports.BUTTON_SWITCH_TO_OFFLINE = 'vô hình'

    exports.BUTTON_MODIFY = 'đổi'

    exports.BUTTON_UNFORBID_ALL = 'hủy bỏ lệnh cấm'

    exports.BUTTON_COMMENT_REQ_MORE = 'xem tiếp đi'

    exports.BUTTON_COMMENT_NO_MORE = 'rốt cuộc rồi.'

    exports.BUTTON_UPGRADE_CLIENT = 'nâng cấp phiên bản mới'

    exports.BUTTON_USE_GUIDE = 'tiếp tân'

    exports.BUTTON_SWITCH_OPEN = 'mở'

    exports.BUTTON_SWITCH_CLOSE = 'đóng'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ME = 'chỉ cần nhìn tôi.'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_TEACHER = 'nhìn cô giáo kìa.'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ALL = 'nguyên'

    exports.BUTTON_SETTING_MORE_DETAIL = 'thêm thiết lập'

    exports.BUTTON_BARRAGE_ON = 'Đạn nổ rồi.'

    exports.BUTTON_BARRAGE_OFF = 'chuyển qua trại'

    exports.BUTTON_SYSTEM_SOUND = 'Âm thanh hệ thống'

    exports.BUTTON_SWITCH_LAYOUT = 'thay đổi kiểu'

    exports.BUTTON_FORBID_RAISE_HAND_OFF = 'giơ tay lên'

    exports.BUTTON_FORBID_RAISE_HAND_ON = 'không tay'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_OFF = 'học sinh được phép giơ tay lên.'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_ON = 'học sinh không được phép giơ tay'

    exports.BUTTON_SELL_PRODUCT = 'hàng'

    exports.BUTTON_SHOP = 'Xe bán hàng'

    exports.BUTTON_SELL_VIDEO_LAYOUT = 'Mẫu Video Thuần'

    exports.BUTTON_SELL_PPT_LAYOUT = 'Mẫu Bán hàng PPT'

    exports.BUTTON_HOMEWORK = 'vùng hoạt động'

    exports.BUTTON_CONFIRM_CANCEL_SCREEN_SHARE_BITRATE_CHANGE = 'lúc này thì không.'

    exports.BUTTON_CONFIRM_OK_SCREEN_SHARE_BITRATE_CHANGE = 'chia lại'

    exports.BUTTON_TOGGLE_VIDEO_AND_DOC = 'đổi cửa sổ'

    exports.BUTTON_MAIN_SCREEN_NOTICE = 'thông báo màn hình chính'

    exports.BUTTON_ASSISTANT_OPTIONS = 'phụ trách giảng dạy'

    exports.BUTTON_USER_AUTH_INFO = 'bỏ quyền xem'

    exports.BUTTON_REPORT = 'báo cáo'

    exports.BUTTON_REWARD_RANKING = 'hạng giải'

    exports.BUTTON_RUSH_TO_ANSWER = 'comment'

    exports.BUTTON_TRANSFER_CLASS_START = 'Bắt đầu truyền hình'

    exports.BUTTON_TRANSFER_CLASS_END = 'Kết thúc buổi phát'

    exports.BUTTON_GIFT_ANIMATION = 'Tác dụng Quà'

    exports.BUTTON_HIDE_GIFT_ANIMATION = 'Hiệu ứng khiên'

    exports.BUTTON_SHOW_GIFT_ANIMATION = 'Hiệu ứng Hiển thị'

    exports.BUTTON_REWARDS = 'Phần'

    exports.BUTTON_REWARDS_STATISTICS = 'Thống kê nhập'

    exports.BUTTON_LUCKY_BAG = 'Túi Máu'

    exports.BUTTON_CASH_WITHDRAW = 'Rút'

    exports.BUTTON_VIDEO_LAYOUT = 'Dòng đẩy tùy chỉnh'

    exports.BUTTON_ON_OFF_STAGE = 'thay phiên nhau lên sân khấu.'

    exports.BUTTON_ACTIVITY = 'Hoạt động'

    exports.BUTTON_MESSAGE_CHECK = 'Kiểm tra cuộc trò chuyện'

    exports.BUTTON_TURN_OFF_ALL_USERS = 'Tắt tất cả'

    /**
     * =================================================
     * 标签
     * =================================================
     */

    exports.TAB_ALL_USER_LIST = 'người dùng'

    exports.TAB_ACTIVE_USER_LIST = 'máy phát thanh'

    exports.TAB_CHAT = 'chat'

    exports.TAB_ANSWER_LIST = 'q*u. a'

    exports.TAB_RESEARCH_GROUP = 'Research'

    exports.TAB_USER_LIST_HIDE = 'người'

    exports.TAB_CLASS_STARTED = 'sống'

    exports.TAB_TIME_SORT = 'Sắp xếp thời gian'

    exports.ANSWER_SORT_TYPE_SUBMIT = 'Sắp xếp theo thời gian gửi'

    exports.ANSWER_SORT_TYPE_OPERATE = 'Sắp xếp theo thời gian hoạt động'

    /**
     * =================================================
     * 普通提示
     * =================================================
     */

    exports.INFO_CLASS_START = 'hạng'

    exports.INFO_CLASS_END = 'lớp học đã hết'

    exports.INFO_SPEAK_APPLY_TIMEOUT
        = 'thầy giáo đã không trả lời một thời gian dài, và việc giơ tay đã bị hủy bỏ t ự động.'

    exports.INFO_SPEAK_INVITE_TIMEOUT
        = '${userName} đã lâu không trả lời hoặc sử dụng phiên bản ứng dụng khách cũ, lời mời đã bị hủy'

    exports.INFO_SPEAK_OPEN_TIMEOUT
        = '${userName} đã không trả lời trong một thời gian dài hoặc sử dụng phiên bản cũ của ứng dụng khách và đã tự động hủy bài phát biểu mở đầu'

    exports.INFO_SPEAK_OPEN_SUCCESS
        = '${userName} đã được mở để phát biểu, bạn có thể vào "danh sách các bài phát biểu" để xem'

    exports.INFO_HAS_BEEN_OPENED_SPEAKING = 'thầy giáo đã sắp xếp để con nói bằng giọng'

    exports.INFO_HAS_BEEN_OPENED_WEBMIC = 'thầy giáo đã bật micro của anh lên.'

    exports.INFO_HAS_BEEN_CLOSED_WEBMIC = 'thầy giáo đã tắt microphone.'

    exports.INFO_HAS_BEEN_OPENED_WEBCAM = 'thầy giáo đã bật máy quay của em'

    exports.INFO_HAS_BEEN_CLOSED_WEBCAM = 'thầy giáo đã tắt máy quay của anh.'

    exports.INFO_OPEN_WEBCAM_FAILED = 'lỗi mở video. nhấn vào nút để thử lại lần nữa'

    exports.INFO_WEAR_EARPHONE_WHEN_SPEAKING = 'Để tránh echoes và tiếng huýt sáo, hãy đeo tai nghe'

    exports.INFO_RECEIVE_MESSAGE = 'bạn có tin tức'

    exports.INFO_SPEAK_INVITE_ACCEPT = '${userName} đã đồng ý phát biểu'

    exports.INFO_SPEAK_INVITE_REJECT = '${userName} đã từ chối phát biểu'

    exports.INFO_SPEAK_APPLY_ACCEPT = 'thầy giáo đã cho phép anh nói'

    exports.INFO_SPEAK_APPLY_REJECT = 'xin hãy gọi lại sau.'

    exports.INFO_END_SPEAK_BY_TEACHER = 'thầy giáo kết thúc bài phát biểu'

    exports.INFO_DEVICE_IS_STARTING = 'thiết bị âm thanh và video đang khởi động, xin đợi'

    exports.INFO_CAN_NOT_DO_BEFORE_END_SETTINGS = 'anh không thể làm thế này cho đến khi đã đặt xong'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_TEACHER = 'xin hãy nhắp vào cái nút hạng trước.'

    exports.INFO_CAN_NOT_OPEN_CAMERA_AND_MIC = 'thầy giáo không được phép bật máy ảnh và mícrô.'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_STUDENT = 'chưa khởi chạy'

    exports.INFO_CAN_NOT_DO_BEFORE_APPLY = 'xin hãy giơ tay lên trước.'

    exports.INFO_NO_AVAILABLE_CAMERA = 'không có máy ảnh'

    exports.INFO_NO_AVAILABLE_MIC = 'không có micro'

    exports.INFO_FORBID_SEND_MESSAGE_TO_OPERATOR = 'trợ từ đã tắt'

    exports.INFO_UNFORBID_SEND_MESSAGE_TO_OPERATOR = 'việc cấm ăn ta đã bị loại bỏ.'

    exports.INFO_FORBID_SEND_MESSAGE_TO_TARGET = 'giáo viên không cho phép trò chuyện.'

    exports.INFO_FORBID_SEND_MESSAGE_END = 'thầy giáo đã cấm anh đấy.'

    exports.INFO_CLIENT_AUTO_UPGRADE = 'phiên bản khách hàng của bạn quá cũ, nâng cấp tự động'

    exports.INFO_CLIENT_AUTO_UPGRADE = 'Kiểu thiết bị cuối không được sắp xếp, xin dùng phiên bản khách mới nhất để xem'

    exports.INFO_SURVEY_REPLY_RIGHT = 'chúc mừng, trả lời đúng!'

    exports.INFO_SURVEY_REPLY_WRONG = 'trả lời sai rồi.'

    exports.INFO_SURVEY_REPLY_FREE = 'không có câu trả lời cho câu hỏi này.'

    exports.INFO_SURVEY_NO_QUESTION = '"không vấn đề gì, có thể giáo viên là bằng miệng"'

    exports.INFO_SURVEY_OPTION_HINT = 'nhấn vào các tùy chọn'

    exports.INFO_SURVEY_CHOOSE_OPTION = '<span class="arrow">↙</span>kiểm tra câu trả lời đúng'

    exports.INFO_SURVEY_SELF_CHOOSE = 'tùy anh chọn:'

    exports.INFO_COMMENT_SUCC = 'Đánh giá thành công'

    exports.INFO_COMMENT_BEFORE_CLASS = 'vui lòng bình luận sau'

    exports.INFO_APPLY_SPEAK_WOULD_DELAY_SOUND = 'có thể có sự trì hoãn giọng nói khi dùng phiên bản web'

    exports.INFO_SPEAK_INVITE_DENY = 'số người nói đã hết, xin hãy thử lại sau.'

    exports.INFO_MEDIA_PUBLISH_DENY = 'số người nói đã hết, xin hãy thử lại sau.'

    exports.INFO_CAN_NOT_CLOSE_CAMERA = 'dòng hiện thời không cung cấp chức năng đóng video'

    // exports.INFO_SWITCH_SERVER_SUCCESS = '已切换至 ${0}';

    exports.INFO_SWITCH_SERVER_SUCCESS = 'Đổi'

    exports.INFO_FORBID_ALL = 'tất cả đã bị cấm.'

    exports.INFO_UNFORBID_ALL = 'tất cả lệnh cấm đã được bãi bỏ.'

    exports.INFO_FORBID_GROUP_ALL = 'tất cả thành viên của nhóm này đều bị cấm.'

    exports.INFO_UNFORBID_GROUP_ALL = 'nhóm này đã hủy mọi điều cấm.'

    exports.INFO_SELF_ABROAD_TIPS
        = 'nếu phát hiện ra bạn đang học ở nước ngoài, sự ổn định của mạng quốc gia có thể không được đảm bảo.<br/>'
        + 'xin hãy kiểm tra xem tốc độ chuyến thăm trung quốc có bình thường không.'

    exports.INFO_TEACHER_ABROAD_TIPS
        = 'các giáo viên được dạy ở nước ngoài vì sự phức tạp của các mạng lưới ngoại quốc,<br/>'
        + 'Âm thanh và video có thể không ổn định, xin hãy hiểu.'

    exports.INFO_OPEN_CAMERA = '${userRole} bật máy ảnh, dữ liệu đang lưu vào bộ đệm'

    exports.INFO_OPEN_ASSIST_CAMERA = '${userRole} bật máy ảnh phụ, dữ liệu đang lưu vào bộ đệm'

    exports.INFO_CLOSE_CAMERA = 'tắt máy quay đi.'

    exports.INFO_OPEN_MIC = '${userRole} bật micrô, dữ liệu đang lưu vào bộ đệm'

    exports.INFO_CLOSE_MIC = 'tắt mic đi.'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_SHARE_PLAY
        = 'làm ơn tắt màn hình chia sẻ và người chơi trước và ngừng chuyển tiếp dòng phát của người thứ ba'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CLOUD_RECORD = 'không thể tắt kiểu nối lên tầng mây được'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'không thể bật sắc đẹp theo chế độ cao, cực quang và 1080p'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = 'sắc đẹp không thể bật theo kiểu hd, cực quang, 720p, 1080p'

    exports.INFO_CLOUD_RECORD_START = 'thu âm mây đã bật'

    exports.INFO_CLOUD_RECORD_STOP = 'không còn thu âm mây nữa.'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_THIRD_PUSH
        = 'trước khi chia sẻ màn hình, xin đừng chuyển kênh của người thứ ba nữa.'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_PLAY_FILE = 'hãy dừng việc chạy tập tin trước khi chia sẻ màn hình'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_SCREEN_SHARE = 'Đừng chia sẻ màn hình trước khi chạy tập tin'

    exports.CONFIRM_STOP_ASSIST_CAMERA_BEFORE_MEDIA_PLAY
        = '<b>bạn có muốn bật lại nhạc truyền thông không?</b>bật quay truyền thông lên sẽ tắt camera thứ hai.'

    exports.CONFIRM_STOP_MEDIA_PLAY_BEFORE_OPEN_ASSIST_CAMERA
        = '<b>anh có muốn bật máy quay phụ trợ không?</b>bật máy ảnh phụ sẽ tắt đoạn quay truyền thông.'

    exports.INFO_PLAY_LOCAL_MEDIA_FILE = 'bật tập tin cục bộ'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_THIRD_PUSH
        = 'Đừng có gửi đoạn video của người thứ ba trước khi bật tập tin cục bộ'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SCREEN_SHARE
        = 'xin dừng chia sẻ màn hình trước khi chuyển tiếp dòng đẩy của người thứ ba'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_WHEN_COLLECT_SYSTEM_SOUND
        = 'không thể chơi tập tin cục bộ sau khi tải âm thanh hệ thống'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_COLLECT_SYSTEM_SOUND
        = 'hãy hủy hệ thống mua âm thanh trước.'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_PLAY_LOCAL_MEDIA_FILE
        = 'làm ơn đóng đoạn mở lại tập tin cục bộ trước'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_MEDIA_FILE_PLAY
        = 'sau khi chơi tập tin cục bộ, bạn sẽ không thể thu thập âm thanh hệ thống'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SHARE_DESKTOP
        = 'xin dừng chia sẻ màn hình trước khi chuyển tiếp dòng đẩy của người thứ ba'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START = 'Đang tạo ra playback. không thể dùng ghi âm mây trong bài học này.'

    exports.INFO_CLOUD_RECORD_START_COUNT_WARNING = 'Thường xuyên tạm dừng có thể ảnh hưởng đến chất lượng phát lại. Vui lòng thử lại sau.'

    exports.INFO_GET_PLAYBACK_STATUS_FAIL = 'lỗi lấy lại trạng thái thế hệ sao lưu, hãy thử lại'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP
        = '<p class="large">bạn có muốn bắt đầu phát lại nhạc bây giờ không?</p> <p class="error">(sau khi bật lại, ghi âm đám mây sẽ không còn tồn tại sau trong bài học này.)</p>'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP_LONG_TERM
        = '<p class="large">bạn có muốn bắt đầu phát lại nhạc bây giờ không?</p>'

    exports.INFO_SEND_IMAGE_POST_DATA_ERROR = 'lỗi phân tách dữ liệu'

    exports.INFO_CAN_NOT_DETECT_DEVICE_DURING_SPEAKING = '系统检测前请先终止发言'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CONSISTENSY
        = 'kiểu liên kết đã được cấu hình đồng thời. thiết lập này sẽ không có tác dụng.'

    exports.INFO_CLOSE_BARRAGE_TIP = 'nếu bạn cần dùng chổi, hãy tắt hiệu ứng màn hình viên trước'

    exports.INFO_SETTING_FORBID_BY_CLASS_STARTED = 'thiết lập này không thể thay đổi trong lớp'

    exports.INFO_RTMP_NOT_RUNNING = 'thầy giáo không đẩy dòng nước'

    exports.INFO_HAS_FORBID_MIC = 'mọi micro đều tắt.'

    exports.INFO_HAS_BEEN_MUTED = 'thầy giáo đã tắt toàn bộ microphone.'

    exports.INFO_MESSAGE_COPY_SUCCESS = 'tải về đã sao chép'

    exports.INFO_QA_COPY_SUCCESS = 'q. có một nội dung được sao chép'

    exports.INFO_QA_COPY_FAIL = 'không thể sao chép ứng dụng tìm kiếm. hãy sao chép nó bằng tay.'

    exports.INFO_PLAYER_PAUSE_BY_MIC_OFF = 'Để tiếp tục chơi tập tin, hãy bật micro của bạn lên.'

    exports.INFO_USER_ACTIVE_ADD_DENY = 'số loa đã đầy. xin hãy tắt âm thanh và video của các học sinh khác trước.'

    exports.INFO_ENROLL_START = 'Đang đăng ký'

    exports.CLASSROOM_COUNTDOWN_TITLE = 'Truyền hình trực tiếp bắt đầu trong'

    exports.INFO_GIFT_ANIMATION_ENABLE = 'Phản ứng năng lượng bật'

    exports.INFO_GIFT_ANIMATION_DISABLE = 'Hiệu ứng đặc biệt của món quà đã tắt.'

    exports.INFO_NO_CAMERA_OPERATION_PERMISSION = 'không có quyền vào máy ảnh'

    /**
     * =================================================
     * 空状态提示
     * =================================================
     */
    exports.INFO_NO_SPEAKER = 'không ai khác nói'

    /**
     * =================================================
     * 警告提示
     * =================================================
     */

    exports.WARNING_INPUT_FREQUENT = 'xin đừng quẹt màn hình.'

    exports.WARNING_INPUT_EMPTY = 'nhập vào nội dung chat'

    exports.WARNING_INPUT_OVERLENGTH = 'xin đừng nhập quá lâu nội dung'

    exports.WARNING_CAMERA_SWITCH_FREQUENT = 'xin đừng bật và t ắt máy ảnh thường xuyên'

    exports.WARNING_MIC_SWITCH_FREQUENT = 'xin đừng bật và t ắt micro thường xuyên.'

    exports.WARNING_CLOSE_DIALOG_ON_DOCUMENT_UPLOADING = 'các tập tin đang được tải lên, xin hãy kiên nhẫn chờ đợi.'

    exports.WARNING_SEND_MESSAGE_FORBID = 'bạn đã bị cấm nói chuyện'

    exports.WARNING_SURVEY_OPTION_HINT = 'nhấn vào thư số seri để đặt câu trả lời đúng.'

    exports.WARNING_SURVEY_TEXTAREA_MAX = 'xin đừng có nhiều hơn trăm t ừ!'

    exports.WARNING_SURVEY_OPTION_MAX = 'xin đừng chọn nhiều hơn khẩu 25 từ!'

    exports.WARNING_VOLUME_OVERFLOW = 'tăng cường có thể gây méo mó'

    exports.WARNING_COMMENT_TEXT_HINT = 'bạn cũng có thể vào'

    exports.WARNING_COMMENT_TEXT_UNIT = 'từ'

    exports.WARING_COMMENT_NO_TEXT = 'xin nhập bản đánh giá của giáo viên'

    exports.WARING_COMMENT_NO_CONTENT = 'xin nhập vào bảng đánh giá tổng thể của giáo viên'

    exports.WARING_COMMENT_UPLOAD_FULL = 'cộng với năm ảnh'

    exports.WARNING_SWITCH_CDN_SERVER
        = 'các giáo viên chuyển đổi đường dây sẽ khiến tất cả học sinh tự động trở lại lớp học, bạn có chắc sẽ thay đổi không?'

    exports.WARNING_ABROAD_CONFIRM = 'hiểu rồi.'

    exports.WARNING_ABRAOD_TIPS = 'nhắc'

    exports.WARING_PLAY_FILE_FAILED = 'lỗi chơi tập tin, kiểu tập tin không được hỗ trợ hay đoạn video gỡ bỏ'

    exports.WARING_PLAY_FILE_LENGTH_FAILED = 'vui lòng tải một tập tin âm thanh/ video ít nhất là 1\'s!'

    exports.WARN_WEBRTC_MEDIA_DEVICE_PERMISSON_DENY
        = '${authType} không khởi động được, vui lòng cho phép chúng tôi có quyền truy cập vào ${deviceType}'

    exports.WARN_NO_AUTH_QUIZ = 'bạn đã bị tắt'

    exports.WARN_NO_AUTH_ANSWER = 'bạn bị tắt khi xin phép máy trả lời'

    exports.RISK_ASSESSMENT = 'Đánh giá rủi ro'

    /**
     * =================================================
     * 成功提示
     * =================================================
     */

    exports.SUCCESS_UPLOAD_DOCUMENT = 'tải thành công, chuyển mã, đợi đã'

    exports.SUCCESS_DETECT_CAMERA = 'phát hiện máy ảnh'

    exports.SUCCESS_DETECT_ASSIST_CAMERA = 'thiết bị camera phụ phát hiện thành công'

    exports.FAIL_DETECT_ASSIST_CAMERA = 'thiết bị camera phụ không phát hiện'

    /**
     * =================================================
     * 错误提示
     * =================================================
     */

    exports.ERROR_RECORD_FAIL_ON_PATH_NOT_EXIST = 'không tồn tại, không thể ghi lại lộ trình'

    exports.ERROR_RECORD_FAIL_ON_DISK_NOT_ENOUGH = 'không có đủ không gian đĩa để ghi lại lộ trình'

    exports.ERROR_UPLOAD_DOCUMENT = 'lỗi tải lên'

    exports.ERROR_DOCUMENT_TYPE_NOT_SUPPORT = 'lỗi định dạng tập tin, xin hãy tải từ, ppt, pdf hoặc định dạng ảnh'

    exports.ERROR_DOCUMENT_SIZE_NOT_SUPPORT = 'vui lòng tải một tập tin ít hơn 50m'

    exports.ERROR_DOCUMENT_NAME = 'tên tập tin chứa dấu chấm, hãy sửa đổi tên tập tin và tải lên lần nữa.'

    exports.ERROR_GET_GIFT_PAY_URL = 'giao hàng thất bại, thử lại đi.'

    exports.ERROR_RUN_CEF_FAIL = 'khởi tạo khách bị lỗi, xin khởi động lại khách'

    exports.ERROR_NOT_SURPORT_SELL_TEMPLATE = 'máy tính không hỗ trợ, xin hãy nhập qua h5'

    /**
     * =================================================
     * 邀请函
     * =================================================
     */

    exports.ENTER_CLASSROOM_BY_JOIN_CODE = 'chế độ tham nhũng'

    exports.ENTER_CLASSROOM_WITH_SECRET = 'Ứng dụng chế độ lệnh mật'

    exports.JOIN_CODE = 'mã tham gia'

    exports.JOIN_CODE_SPECIFICATION = 'hướng dẫn sử dụng mật mã tham gia'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_DAYS = 'ngày '

    // 为了使倒计时的时间数字和量词之间不会挨在一起，要在‘时’和‘分’后加一个空格
    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_HOURS = 'giờ '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_MINUTES = 'chi '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_SECONDS = 'giây'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TITLE = 'mẹo'

    exports.CLASS_START_TIME = 'giờ khởi chạy'

    exports.TEACH_DURATION = 'giờ dạy học'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_LABEL = 'hãy nhập tên thật của bạn:'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TIP = 'nhập không thể rỗng'

    exports.INVITATION_TITILE_HINT = 'mẹo'

    exports.INVITATION_TIP_OPENING_CLIENT = 'Đang cố gắng mở khách hàng'

    exports.INVITATION_BUTTON_DOWNLOAD_CLIENT = 'tải về'

    exports.INVITATION_BUTTON_ENTER_CLASSROOM_VIA_WEB = 'trang web vào lớp'

    exports.INVITATION_LABEL_OTHER_METHOD_ENTER_CLASSROOM = 'các con đường khác để vào lớp'

    exports.INVITATION_TIP_ADVICE_DOWNLOAD_CLIENT
        = 'nếu khách hàng không được cài đặt hay không thể mở, xin hãy tải chương trình mới nhất. khách hàng có thể xem chương trình truyền hình trực tiếp trơn tru và mạnh hơn.'

    /**
     * =================================================
     * 倒计时
     * =================================================
     */

    exports.CLASSROOM_ENTER_COUNT_DOWN_TIP = 'Ừm .. ${preEnterTimeText} có thể vào phòng trước khi bắt đầu'

    exports.CLASS_EXPIRE_TIP = 'truyền hình trực tiếp kết thúc rồi.'

    exports.CLASS_DELETED_TIP = 'cuộc truyền hình trực tiếp đã bị hủy bỏ'

    exports.CLASSROOM_ENTER_TIP_STRING_DAYS = 'ngày'

    exports.CLASSROOM_ENTER_TIP_STRING_HOURS = 'giờ'

    exports.CLASSROOM_ENTER_TIP_STRING_MINUTES = 'phút'

    exports.CLASSROOM_ENTER_TIP_STRING_SECONDS = 'giây'

    exports.BUTTON_ENTER = 'Vào phòng trực'

    /**
     * =================================================
     * 试听课
     * =================================================
     */
    exports.TRIAL_START_TIP
        = 'hãy thử nghe ${leftMinutes} phút, để xem toàn bộ chương trình phát sóng trực tiếp, vui lòng <span class = "register"> đăng ký ngay </span>'

    exports.TRIAL_END_TIP
        = 'buổi thử vai s ắp kết thúc, nên tôi cảm thấy bài diễn văn của thầy giáo rất tốt.<span class="enroll">Đăng ký ngay.</span>thanh'

    exports.COURSE_ENROLL_HREF = 'Đăng ký ngay.'

    exports.FORBIDDEN_BTN_TIP = 'chỉ sau khi nhập ngũ, chúng ta mới có thể trò chuyện với giáo viên.'

    exports.TRIAL_LEAVE_NOTICE = 'cậu có chắc là sẽ rời khỏi phòng thử giọng không?'

    /**
     * =================================================
     * 确认
     * =================================================
     */

    exports.CONFIRM_END_CLASS = 'cậu có chắc là muốn rời khỏi lớp không?'

    exports.CONFIRM_END_SPEAK = 'anh có chắc là muốn kết thúc không?'

    exports.CONFIRM_END_WARMING_UP = 'anh có chắc kết thúc để khởi động không?'

    exports.CONFIRM_STOP_RECORD = 'anh có chắc là muốn dừng ghi hình lại không?'

    exports.CONFIRM_STOP_SCREEN_SHARE = 'bạn có chắc muốn ngừng chia sẻ màn hình nền?'

    exports.CONFIRM_SWITCH_LINK_TYPE = 'mạng của bạn không ổn định. bạn có muốn chuyển dạng liên kết không?'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_CLOSE_CAMERA
        = 'tắt máy ảnh sẽ ngừng chia sẻ màn hình nền. bạn có chắc muốn tắt nó không?'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_OPEN_CAMERA
        = 'bật máy ảnh sẽ ngừng chia sẻ màn hình nền. bạn có chắc muốn bật nó không?'

    exports.CONFIRM_RELOAD_ON_WEBSOCKET_CLOSE_BJY = 'dường như anh đã ngắt kết nối, kiểm tra mạng và thử lại?'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_SCREEN_SHARE
        = 'máy ảnh phải được bật trước khi chia sẻ màn hình nền. bạn có muốn bật nó không?'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_PLAY_MEDIA
        = 'Để chơi các tập tin ảnh địa phương, máy ảnh phải được bật trước. bạn có muốn bật nó lên không?'

    exports.CONFIRM_UPGRADE_BEFORE_USE
        = 'phiên bản khách hàng hiện thời của bạn quá thấp để nhận giọng và video của giáo viên bình thường. xin hãy nâng cấp thân chủ mới nhất.'

    exports.CONFIRM_UPGRADE_HINT
        = 'phiên bản khách hiện thời của bạn quá thấp, xin hãy nhắp vào nút cập nhật để tải xuống khách hàng mới nhất,<br />kinh nghiệm chức năng giàu'

    exports.CONFIRM_EXIT_CLASSROOM = 'Có nên rời phòng trực tiếp hay không?'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLASS
        = 'nếu bạn rời lớp học trong lớp, lớp học sẽ tự động kết thúc. bạn có chắc không?'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLOUD_RECORD
        = 'trong suốt đoạn ghi âm, rời lớp học sẽ tự động kết thúc lớp học và dừng đoạn ghi âm đám mây.'

    exports.CONFIRM_USE_CAMERA_ON_NO_AVAILABLE_CAMERA = 'không thấy camera nào, anh có cần dùng máy quay không?'

    exports.CONFIRM_USE_MIC_ON_NO_AVAILABLE_MIC = 'anh có cần dùng micro không?'

    exports.CONFRIM_FORBID_USER_SEND_MESSAGE = 'anh có chắc muốn tắt đối tác trợ giảng không?'

    exports.CONFIRM_REMOVE_DOCUMENT = 'bạn có chắc muốn xoá những dòng này không?'

    exports.CONFIRM_REMOVE_HOMEWORK = 'bạn có chắc muốn xóa bỏ công việc này?'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_CAMERA
        = 'không phát hiện thiết bị camera nào, bạn có muốn bị phát hiện lại không?'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_ASSIST_CAMERA
        = 'không phát hiện thiết bị hỗ trợ của máy quay, anh có muốn phát hiện lại nó không?'

    exports.CONFIRM_PURCHASE = 'anh chưa đăng ký khóa học, anh có muốn đăng ký trước không?'

    exports.CONFIRM_TO_TCP_LINK = 'việc bật kết nối tcp sẽ khiến cho giọng nói của sinh viên không thể được ghi lại.'

    exports.CONFIRM_END_RTMP_PUSH = 'cậu có chắc là muốn chấm dứt dòng ép của thầy giáo không?'

    exports.CONFIRM_SCREEN_SHARE_BITRATE_CHANGE
        = 'tỷ lệ chia sẻ của màn hình phòng phát sóng trực tiếp đã thay đổi. hãy nhắp vào lại chia sẻ để có tác dụng.'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_TITLE = 'kết nối máy tính bảng'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_CONTENT
        = 'kết nối phiến đá thất bại, kết nối lại<br>hãy đảm bảo rằng máy tính bảng bên ngoài vẫn mở và nằm trong phạm vi liên lạc.'

    exports.CONFIRM_BUTTON_CONNECT_HAND_WRITTING_BOARD = 'nối'

    exports.CONFIRM_PIP_ERR = 'Khi khởi tạo, xin hãy nhắp vào « OK » để có tác dụng của chức năng « Hiển thị mặt bạn ».'

    exports.CONFIRM_TURN_OFF_ALL_USERS = 'bạn có chắc muốn tắt tất cả các micro không?'

    /**
     * =================================================
     * Tooltip
     * =================================================
     */

    exports.TOOLTIP_LASER = 'bút laze'

    exports.TOOLTIP_MOVE = 'Đi!'

    exports.TOOLTIP_DOODLE = 'cọ vẽ'

    exports.TOOLTIP_TEXT = 'chữ viết'

    exports.TOOLTIP_ARROW = 'tên'

    exports.TOOLTIP_RECT = 'color'

    exports.TOOLTIP_ERASER = 'xóa'

    exports.TOOLTIP_CLEAR = 'rỗng'

    exports.TOOLTIP_SMILE = 'cười'

    exports.TOOLTIP_GIGGLE = 'nụ cười đơn giản'

    exports.TOOLTIP_PROUD = 'kiêu hãnh'

    exports.TOOLTIP_NAUGHTY = 'nghịch ngợm'

    exports.TOOLTIP_EXHAUSTED = 'em buồn ngủ quá'

    exports.TOOLTIP_CRY = 'khóc'

    exports.TOOLTIP_EMBARRASSED = 'cuộn tròn'

    exports.TOOLTIP_DOUBT = 'ngờ'

    exports.TOOLTIP_APPEARANCE = 'màu'

    exports.TOOLTIP_POWERFUL = 'description'

    exports.TOOLTIP_WORSHIP = 'thờ'

    exports.TOOLTIP_STRUGGLE = 'Đánh mạnh vào.'

    exports.TOOLTIP_WEIGHS = 'color'

    exports.TOOLTIP_SURPRISE = 'ngạc nhiên'

    exports.TOOLTIP_SPEECHLESS = 'không.'

    exports.TOOLTIP_HEARTSTOPPER = 'giảm'

    /**
     * =================================================
     * 对话框
     * =================================================
     */

    exports.DIALOG_MANAGE_DOCUMENT = 'chọn tập tin'

    exports.DIALOG_MANAGE_HOMEWORK = 'vùng hoạt động'

    exports.DIALOG_DEBUG = 'chỉ dẫn sửa lỗi'

    exports.USER_DIALOG_DEBUG = 'thông tin giáo'

    exports.ALERT_DEFAULT_TITLE = 'mẹo'

    exports.DIALOG_QUESTION_ANSWER = 'q*u. a'

    exports.DIALOG_DEBUG_PANEL = 'Ủy viên gỡ lỗi'

    exports.DIALOG_MESSAGE_BOX_PUBLIC = 'trò chuyện phiếm'

    exports.DIALOG_MESSAGE_BOX_RESEARCH = 'Nhóm nghiên cứu'

    exports.DIALOG_MESSAGE_BOX_WHISPER = 'Trò chuyện-trò chuyện riêng với {user-name}'

    exports.DIALOG_USER_AUTH_TITLE = 'lời khuyên thân thiện'

    exports.MORE_BUTTON_TITLE = 'Thêm các tính năng'

    exports.MORE_BUTTON_TITLE_EDIT = 'soạn thảo'

    exports.DIALOG_REPORT_TITLE = 'Vui lòng chọn lý do báo cáo'

    /**
     * =================================================
     * 空文本占位符
     * =================================================
     */

    exports.PLACEHOLDER_NOTICE_FOR_WRITER = 'Đây là thông báo lớp'

    exports.PLACEHOLDER_NOTICE_GROUP_FOR_WRITER = 'bạn có thể gửi thông báo nhóm ở đây~'

    exports.PLACEHOLDER_NOTICE_FOR_READER = 'bảng tin đã hết'

    exports.PLACEHOLDER_INPUT_AMOUNT = 'xin nhập số lượng'

    exports.PLACEHOLDER_COMMENT_FOR_SEND = 'hãy viết về bài đánh giá của thầy nào.'

    /**
     * =================================================
     * 一些杂七杂八的话术
     * =================================================
     */

    exports.LABEL_RECORDING = 'thu âm'

    exports.LABEL_WECHAT_HELP = 'trợ giúp mạngname'

    exports.LABEL_STUDENT_JOIN_CLASS_NO = 'học sinh không vào lớp'

    exports.LABEL_STUDENT_JOIN_CLASS_YES = 'học sinh đã vào lớp'

    exports.LABEL_FAIL_AGAIN = 'vẫn thất bại?'

    exports.LABEL_CONTACT_TEL = 'khách có thể gọi:'

    exports.LABEL_CONTACT_QQ = 'hay thêm hỗ trợ kỹ thuật qq: 33000897'

    exports.LABEL_CLASSROOM_ID_TEXT = 'hạng cước'

    exports.LABEL_TOUCH_SCREEN_SUPPERT = 'hỗ trợ màn hình chạm'

    exports.LABEL_VIDEO_POPUP_TO_AUX_SCREEN = 'Đoạn phim bật lên màn hình phụ trợ'

    exports.LABEL_REPAIR_PROGRAM_SHARE = 'sửa ảnh màu đen chung'

    exports.LABEL_MEDIA_PANEL = 'khu người dùng'

    exports.LABEL_MESSAGE_PANEL = 'tranh luận văn bản'

    exports.LABEL_LOADING = 'name'

    exports.LABEL_DATA_LOADING = 'tải dữ liệu lên, xin đợi'

    exports.LABEL_VIDEO = 'video'

    exports.LABEL_AUDIO = 'tần số âm'

    exports.LABEL_AUDIO_AND_VIDEO = 'Âm thanh và video'

    exports.LABEL_WHITEBOARD = 'màu:'

    exports.LABEL_CAMERA = 'máy ảnh'

    exports.LABEL_MIC = 'comment'

    exports.LABEL_MIC_AND_CAMERA = 'máy ảnh điện thoại'

    exports.LABEL_SPEAKER = 'name'

    exports.LABEL_RECORD = 'ghi lưu lộ trình'

    exports.LABEL_SHARE = 'chia màn hìnhname'

    exports.LABEL_CLASS_SETTING = 'quản lý phòng'

    exports.LABEL_OTHER = 'khác'

    exports.LABEL_DEVICE_LIST = 'trang bị'

    exports.LABEL_AUDIO_REPAIR = 'sửa vết thương'

    exports.LABEL_AUDIO_REPAIR_NO = 'không cần phải sửa'

    exports.LABEL_AUDIO_REPAIR_LEFT = 'sửa chữa đường thanh quản trái'

    exports.LABEL_AUDIO_REPAIR_RIGHT = 'sửa đúng đường thẳng'

    exports.LABEL_INPUT_VOLUME = 'tập tin nhập'

    exports.LABEL_OUTPUT_VOLUME = 'cấp xuất'

    exports.LABEL_AGC = 'lợi nhuận tự động'

    exports.LABEL_POPUP = 'đẩy'

    exports.LABEL_CLOSE = 'đóng'

    exports.LAEBL_CLOSE_MIC = 'đóng'

    exports.LABEL_PRIMARY_CAMERA_SETTING = 'thiết lập máy ảnh'

    exports.LABEL_MINOR_CAMERA_SETTING = 'thiết lập máy ảnh'

    exports.LABEL_NO_AVAILABLE_CAMERA = 'không có máy ảnh'

    exports.LABEL_NO_AVAILABLE_MIC = 'không có micro'

    exports.LABEL_NO_AVAILABLE_SPEAKER = 'không có loa'

    exports.LABEL_VIDEO_QUALITY = 'chất lượng video'

    exports.LABEL_CAN_YOU_HEAR_YOUR_VOICE = 'nói đi, nghe giọng anh không?'

    exports.LABEL_APPLY_BEFORE_SPEAK = 'xin hãy giơ tay lên trước.'

    exports.LABEL_WAIT_TEACHER_ACCEPT = 'xin hãy đợi s ự đồng ý của thầy.'

    exports.LABEL_SPEAK_APPLYING = 'giơ tay lên'

    exports.LABEL_TEACHER_SPEAK_INVITING = 'thầy giáo mời cô nói về lúa mì'

    exports.LABEL_DOCUMENT_IN_LIBRARY = 'dữ liệu'

    exports.LABEL_DOCUMENT_IN_USE = 'dịch vụ mạngcomment'

    exports.LABEL_DOCUMENT_TYPE_HINT = 'vì những tài liệu được soạn bởi wbs, hãy chuyển đổi thành pdf và tải chúng lên'

    exports.LABEL_DOCUMENT_HELP_LINK = 'nhấn vào đây để xem hướng dẫn chuyển đổi'

    exports.LABEL_PAGE_LOADING = 'luyện tập đang nạp'

    exports.LABEL_DOCUMENT_TRANSFORMING = 'tài liệu đang tìm cách chuyển đổi, xin hãy đợi'

    exports.LABEL_DOCUMENT_TRANSFORMING_TIP = 'dịch'

    exports.LABEL_DOCUMENT_TRANSFORM_COMPLETE_TIP = 'dịch xong'

    exports.LABEL_DOCUMENT_TRANSFORM_FAIL = 'lỗi chuyển đổi tài liệu, xin tải lại'

    exports.LABEL_CLASS_DOCUMENT = 'lớp luyện của tôi'

    exports.lABEL_USER_DOCUMENT = 'Ảnh sinh viên'

    exports.LABEL_UPLINK_BANDWIDTH = 'bề rộng băng'

    exports.LABEL_DOWNLINK_BANDWIDTH = 'chiều ngang băng xuôi dòng'

    exports.LABEL_FORBID_ALL_REMINDER = 'tất cả học sinh bị cấm nói chuyện'

    exports.LABEL_SEND_GIFT_PAY_TITLE = 'cảm ơn, ngài thời ma.'

    exports.LABEL_LOADING_TIMEOUT = 'không vào lớp được à?gọi 4000-910-910 để giúp đỡ'

    exports.LABEL_SURVEY_QUESTION = 'tựa:'

    exports.LABEL_SURVEY_MULTIPLE_ANSWER = 'nhiều lựa chọn'

    exports.LABEL_SURVEY_SEND_TITLE = 'hãy đặt câu hỏi.'

    exports.LABEL_SURVEY_REPLY_TITLE = 'đáp'

    exports.LABEL_SURVEY_REPLY_RESULT = 'kết quả trả lời'

    exports.LABEL_SURVEY_MYCHOICE = 'tùy chọn'

    exports.LABEL_SURVEY_RIGHT_COUNT = 'đáp'

    exports.LABEL_SURVEY_WRONG_COUNT = 'trả lời sai'

    exports.LABEL_SURVEY_OPTION_UNIT = 'người'

    exports.LABEL_SURVEY_TITLE_NAME = 'bảng trả lời'

    exports.LABEL_GIFT_TYPE_ORANGE_JUICE = 'nước cam'

    exports.LABEL_GIFT_TYPE_ICE_TEA = 'trà đen đá'

    exports.LABEL_GIFT_TYPE_BARLEY_TEA = 'trà lúa mạch'

    exports.LABEL_RECORDING_INDICATOR = 'thầy giáo đang ghi lại bài học'

    exports.LABEL_RECORDING_LOCAL = 'địa'

    exports.LABEL_RECORDING_CLOUD = 'mây.'

    exports.LABEL_RECORDING_PUSH = 'thiết lập màn hình'

    exports.LABEL_RECORDING_SUFFIX = 'thu âm'

    exports.LABEL_DOC_QUALITY_HIGH = 'tranh gốc'

    exports.LABEL_DOC_QUALITY_LOW = 'trôi chảy'

    exports.LABEL_DOC_FIT_WIDTH = 'điền'

    exports.LABEL_DOC_FIT_VIEW = 'chỉnh'

    exports.LABEL_COMMENT_REMIND_TITLE = 'Đánh giá lộ trình'

    exports.LABEL_COMMENT_POINT_UNIT = 'chi'

    exports.LABEL_COMMENT_TEACHER_TITLE = 'câu trả lời'

    exports.LABEL_COMMENT_TYPE_TOTAL = 'nguyên'

    exports.LABEL_COMMENT_TYPE_GREAT = 'vinh danh.'

    exports.LABEL_COMMENT_TYPE_MIDDLE = 'hồ sơ trung quốc'

    exports.LABEL_COMMENT_TYPE_LOWER = 'ghi chú tiêu cực'

    exports.LABEL_COMMENT_MAX_LENGHT = '20 từ'

    exports.LABEL_COMMENT_TOTAL_RATER = 'Đánh giá chung'

    exports.LABEL_COMMENT_ANONYMOUS = 'Đánh giá vô danh'

    exports.LABEL_COMMENT_REMARK = 'đánh'

    exports.LABEL_COMMENT_POINT_FIVE = 'năm sao'

    exports.LABEL_COMMENT_POINT_FOUR = 'bốn sao'

    exports.LABEL_COMMENT_POINT_THREE = 'genericname'

    exports.LABEL_COMMENT_POINT_TWO = 'hai sao'

    exports.LABEL_COMMENT_POINT_ONE = 'một chút thôi'

    exports.LABEL_COMMENT_UNIT_TIPS = 'tổng cộng ${totalCount}'

    exports.LABEL_COMMENT_TYPE = 'đánh giá học'

    exports.LABEL_BEAUTIFY_AND_DENOISE = 'sắc đẹp giảm nhiễu'

    exports.LABEL_SETTINGS = 'thiết lập'

    exports.LABEL_AUTH_MANAGEMENT = 'quản lý quản lý'

    exports.LABEL_EYE_PROTECTION = 'chế độ chăm sóc mắt'

    exports.LABEL_SCREENSHOT = 'bắt giữ màn hình'

    exports.LABEL_SCREENSHOT_WITH_ROOM_HIDED = 'bắt giữ màn hình phòng học'

    exports.LABEL_POSITION = 'vị trí ${number}'

    exports.LABEL_DETECT_TOOL = 'hệ thống dò'

    exports.LABEL_FORBID_ALL = 'mọi im lặng'

    exports.LABEL_SHARE_POSITION = 'hiển thị vị trí của ảnh chung trên màn hình'

    exports.LABEL_SHARE_POSITION_MOD_TIP = 'bạn có thể thay đổi nó sau trong thiết lập'

    exports.LABEL_NUMBER_ONE = 'một'

    exports.LABEL_NUMBER_TWO = 'hai'

    exports.LABEL_NUMBER_THREE = 'ba'

    exports.LABEL_NUMBER_FOUR = 'bốn'

    exports.LABEL_NUMBER_FIVE = 'năm'

    exports.LABEL_NUMBER_SIX = 'sáu'

    exports.LABEL_NUMBER_SEVEN = 'bảy.'

    exports.LABEL_NUMBER_EIGHT = 'tám'

    exports.LABEL_NUMBER_NINE = 'chín'

    exports.LABEL_NUMBER_TEN = 'mười'

    exports.LABEL_SERVER_ROUTE = 'dòng ${number}'

    exports.LABEL_OTHER_SERVER_ROUTE = 'những đường khác'

    exports.LABEL_CDN_ROUTE_PRIMARY = 'chính'

    exports.LABEL_CDN_ROUTE_ASSISTANT = 'vice-'

    exports.LABEL_CHECK_ALL = 'chọn tất cả'

    exports.LABEL_UNIT = 'cá nhân'

    exports.LABEL_LINK_TYPE = 'kiểu liên kết'

    exports.LABEL_UPLINK = 'ngược'

    exports.LABEL_DOWNLINK = 'xuống'

    exports.LABEL_comment = 'comment'

    exports.LABEL_udecomment = 'udecomment'

    exports.LABEL_TEACHER = 'giáo viên'

    exports.LABEL_NICKNAME = 'biệt danh?'

    exports.LABEL_DON_NOT_REMIND_ANY_MORE = 'lần sau đừng nhắc t ôi nữa.'

    exports.LABEL_GIFT_PAY_HINT = 'phương pháp thanh toán'

    exports.LABEL_GIFT_WECHAT = 'description'

    exports.LABEL_GIFT_ALIPAY = 'thanh'

    exports.LABEL_COMMENT_RECEIVE_TITLE = 'danh sách đánh giá'

    exports.LABEL_COMMENT_SEND_TITLE = 'Đánh giá lộ trình'

    exports.LABEL_LOTTERY_SEND_TITLE = 'giải'

    exports.LABEL_LOTTERY_SEND_HEADER = '"nói với sinh viên, lần này ngạc nhiên thế nào?"'

    exports.LABEL_LOTTERY_SEND_NAME = 'tên giải thưởng'

    exports.LABEL_LOTTERY_SEND_NUMBER = 'số giải thưởng'

    exports.LABEL_CURRENT_STUDENT_COUNT = 'sinh viên lớp học hiện tại ${userCount} người'

    exports.LABEL_LOTTERY_SEND_HINT
        = 'nếu anh thắng giải, anh có thể có mã giải.<br/>xin hãy liên lạc với học sinh để trao đổi'

    exports.LABEL_LOTTERY_DRAW_HINT = 'thầy giáo sẽ chia giải thưởng theo quy tắc.'

    exports.LABEL_LOTTERY_SEND_BTN = 'gởi quà.'

    exports.LABEL_LOTTERY_UNIT = 'chia'

    exports.LABEL_LOTTERY_REMAIN = 'còn lại gì?'

    exports.LABEL_LOTTERY_SAVE_LIST = 'lưu danh sách'

    exports.LABEL_LOTTERY_DRAW_TIP = 'tôi đã gửi một món quà.'

    exports.LANEL_LOTTERY_DRAW_BTN = 'bỏ phong bì đỏ'

    exports.LABEL_LOTTERY_DRAW_SUCC = 'chúc mừng!anh đã thắng giải.'

    exports.LABEL_LOTTERY_DRAW_CODE = 'mã giải thưởng'

    exports.LABEL_LOTTERY_SHOW_WINNERS = 'nhìn vận may của anh đi.'

    exports.LABEL_LOTTERY_DRAW_FAIL = 'chậm lại, phong bì đỏ đã hết.'

    exports.LABEL_LOTTERY_REDPACK = 'phong bì đỏ'

    exports.LABEL_OF_UNITE = 'của'

    exports.LABEL_INPUT_LOTTERY_NAME = 'hãy nhập tên của giải thưởng'

    exports.LABEL_INPUT_LOTTERY_NUMBER_ERROR = 'hãy nhập số giải thưởng đúng'

    exports.LABEL_INPUT_LOTTERY_OVER_MEMBER = 'số giải thưởng không thể lớn hơn số học sinh'

    exports.LABEL_INPUT_LOTTERY_OVER_MAX = 'số giải thưởng không thể quá 50'

    exports.LABEL_CAMERA_PIXEL_RATIO = 'tỷ lệ ảnh'

    exports.LABEL_CAMERA_SETTING = 'thiết lập ảnh'

    exports.LABEL_CAMERA_FLIP_HORIZONTAL = 'lật ngang'

    exports.LABEL_CAMERA_FLIP_VERTICAL = 'lật dọc'

    exports.LABEL_CAMERA_CROP = 'cắt màn hình'

    exports.LABEL_CAMERA_DISENABLE = 'không bật'

    exports.LABEL_TIP_CLICK_BTN_START_CLASS = 'nhấn vào nút để khởi động lớp'

    exports.LABEL_UPDATE_OLD_CLIENT_VERSION
        = 'phiên bản khách hiện thời quá thấp, xin hãy nâng cấp đến phiên bản mới nhất'

    exports.LABEL_UPDATE_CLIENT_VERSION = 'Đi tải tập tin mới nhất'

    exports.LABEL_CLOSE_CLIENT = 'thân chủ đóng'

    exports.LABEL_CLIENT_INVITE_CODE = 'mã mời khách'

    exports.LABEL_WEB_LINK = 'công cụ comment'

    exports.LABEL_REFRESH_WAITED = 'làm ơn đợi đã'

    exports.LABEL_SHAREING_NO_OPTION = 'hoạt động này không hỗ trợ trong chia sẻ màn hình'

    exports.LABEL_WHISPER_TITLE = 'trò chuyện riêng'

    exports.LABEL_BARRAGE = 'Gạch'

    exports.LABEL_LOCK_SCREEN = 'Khóa học sinh'

    exports.LABEL_RAISE_HAND = 'giơ tay lên'

    exports.LABEL_APPLY_SPEAK = 'Yêu cầu được nói'

    exports.LABEL_SAVE_SUCCESS = 'Lưu thành công！'

    /**
     * =================================================
     * 求助
     * =================================================
     */

    exports.BUTTON_CUSTOM_SERVICE_QQ = 'hỗ trợ qq'

    exports.BUTTON_CUSTOM_SERVICE_TECHNICAL = 'trợ giúp kỹ thuật'

    exports.BUTTON_CUSTOM_SERVICE_CLASS_INFO = 'thông tin giáo'

    exports.DIALOG_TITLE_TECH_HELP = 'trợ giúp kỹ thuật'

    exports.BUTTON_CUSTOM_SERVICE_WECHAT = 'trợ giúp mạngname'

    exports.BUTTON_CUSTOM_SERVICE_OFFICIAL = 'trang web chính thức cần trợ giúp'

    exports.TITLE_HELP_TYPE = 'kiểu trợ giúp'

    exports.TITLE_CONTACT_WAY = 'thông tin liên lạc'

    exports.TYPE_VIDEO_LAG = 'Âm thanh và video caton'

    exports.TYPE_CLIENT_CRASH = 'lỗi hệ thống'

    exports.TYPE_OTHER = 'khác'

    exports.CONTACT_TYPE_qqcomment = 'qqcomment'

    exports.CONTACT_TYPE_PHONE = 'Điện'

    exports.PLACEHOLDER_DESCRIPTION = 'hãy nhập mô tả trợ giúp.'

    exports.INFO_CREATE_HELP_SUCCESS
        = 'Đã gửi trợ giúp kỹ thuật đến các giáo viên liên quan, chúng tôi sẽ liên lạc với các bạn sau!'

    exports.UNKNOW_ERROR = 'gặp lỗi chưa rõ'

    exports.WARING_INVALID_PHONE = 'số di động không đúng'

    exports.WARING_INVALID_QQ = 'số qq không đúng'

    exports.WARING_DESCRIPTION_EMPTY = 'mô tả không thể rỗng'

    exports.SUBMIT_HELP_TOO_FREQUENT = '♪ xin đừng thường xuyên nộp mình để được giúp đỡ ♪'

    /**
     * =================================================
     * 音视频播放器相关话术
     * =================================================
     */

    exports.MEDIA_PLAYER_KEEP_ON = 'vui lòng bật thiết bị av'

    exports.MEDIA_PLAYER_FILE_LOADING = 'Đang tải ${fileName}'

    exports.MEDIA_PLAYER_CLOSE_VIDEO = 'máy ảnh đã được bật. nhấn vào để đóng ảnh.'

    exports.MEDIA_PLAYER_OPEN_VIDEO = 'máy ảnh đã được bật, hãy nhắp để mở ảnh của bên kia.'

    exports.MEIDA_PLAYER_CAMERA_OFF = 'bên kia không bật máy quay.'

    exports.MEDIA_PLAYER_MIC_ON = 'micro đã bật'

    exports.MEDIA_PLAYER_MIC_OFF = 'micro không bật'

    exports.MEDIA_PLAYER_CLOSE_MIC = 'nhấn vào để đóng microphone.'

    exports.MEDIA_PLAYER_POPUP = 'nhấn vào cửa sổ bật lên'

    exports.MEDIA_PLAYER_SWITCH = 'nhấn vào để thay đổi ppd và cửa sổ video'

    exports.MEDIA_PLAYER_VIDEO_DOWNLINK_BANDWIDTH = 'nhận video:'

    exports.MEDIA_PLAYER_AUDIO_DOWNLINK_BANDWIDTH = 'nhận âm thanh:'

    exports.MEDIA_PLAYER_VIDEO_UPLINK_BANDWIDTH = 'tải video lên:'

    exports.MEDIA_PLAYER_AUDIO_UPLINK_BANDWIDTH = 'tải ảnh lên'

    exports.MEDIA_PLAYER_FOLD = 'cất nó đi.'

    exports.MEDIA_PLAYER_UNFOLD = 'mở'

    /**
     * =================================================
     * CEF 相关话术
     * =================================================
     */

    exports.CEF_ERROR_PLAYBACK_AUDIO = 'có gì đó không ổn với thiết bị âm thanh.'

    exports.CEF_ERROR_SYSTEM_NOT_SUPPORT
        = 'hệ điều hành của bạn không hỗ trợ chức năng này. xin hãy thay thế máy tính hoặc nâng cấp hệ điều hành của bạn.'

    exports.CEF_ERROR_CAMERA_IS_BUSY = 'máy ảnh có thể được dùng bởi các ứng dụng khác, xin kiểm tra'

    exports.CEF_ERROR_OPEN_MIC = 'không mở được mícrô. xin hãy khởi động lại khách hàng.'

    exports.ALERT_CREATE_STREAM_TIMEOUT = 'Hãy kiểm tra thiết ị camera và nhớ lại và thử lại.'

    exports.CEF_ERROR_WORK_MIC = 'micro không hoạt động tốt, xin kiểm tra'

    exports.CEF_ERROR_OPEN_SPEAKER = 'lỗi bật loa, khởi động lại máy khách'

    exports.CEF_ERROR_CAPTURE_AUDIO = 'không thu thập được dữ liệu, xin hãy hồi phục khách hàng'

    /**
     * =================================================
     * 需要变量替换的一些话术
     * =================================================
     */

    exports.TPL_LOGIN_CONFLICT
        = 'Tài khoản / mã tham gia của bạn được đăng nhập tại ${endType}, vui lòng xác nhận và đăng nhập lại!'

    exports.TPL_STUDENT_SEND_TEACHER_GIFT = '<em> ${userName} </em> đã tặng quà cho giáo viên'

    exports.TPL_TEACHER_RECEIVE_STUDENT_GIFT = 'nhận quà từ <em> ${userName} </em>'

    exports.TPL_TEACHER_FORBID_USER_SEND_MESSAGE = '<em> ${userName} </em> đã bị giáo viên cấm'

    exports.TPL_CUSTOM_SERVICE_CALL
        = 'Nhấp để xác nhận và gọi cho nhân viên hỗ trợ kỹ thuật <br /> Vui lòng nhận cuộc gọi trên điện thoại di động của bạn <em> ${mobile} </em>'

    exports.TPL_DETECT_TOOL_NET_STATUS_SPEED = '<em> ${netStatusMsg} </em>, độ trễ ${speed} mili giây'

    exports.TIME_NOCTICE_JOIN_CLASS = 'Sẽ quay lại lớp học sau ${seconds} giây'

    /**
     * =================================================
     * 登录注册
     * =================================================
     */

    exports.LOGIN_REGISTER_LOGIN = 'ký vô.'

    exports.LOGIN_REGISTER_REGISTER = 'ghi'

    exports.LOGIN_REGISTER_LOGIN_WAITING = 'Đăng nhập'

    exports.LOGIN_REGISTER_REGISTER_WAITING = 'Đăng ký'

    exports.LOGIN_REGISTER_MOBILE = 'nhập số điện thoại di động'

    exports.LOGIN_REGISTER_SET_PASSWORD = 'xin hãy đặt mật khẩu'

    exports.LOGIN_REGISTER_INPUT_PASSWORD = 'nhập mật khẩu đi.'

    exports.LOGIN_REGISTER_INPUT_VERIFYCODE = 'nhập mật mã kiểm tra điện thoại di động'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE = 'lấy mật khẩu'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE_COUNTING = 'thử lại trong vài giây'

    exports.LOGIN_REGISTER_MOBILE_ERROR = 'hãy nhập số điện thoại di động đúng'

    exports.LOGIN_REGISTER_PASSWORD_ERROR = 'hãy nhập mật khẩu đúng.'

    exports.LOGIN_REGISTER_CAPTCHA_ERROR = 'nhập đoạn mã xác minh đồ họa đúng'

    exports.LOGIN_REGISTER_VERIFYCODE_ERROR = 'hãy nhập mật mã kiểm tra đúng.'

    exports.LOGIN_REGISTER_DIALOG_TITLE = 'xác nhận đăng nhập'

    exports.LOGIN_REGISTER_LOGIN_BY_SMS = 'Đăng nhập sms'

    exports.LOGIN_REGISTER_LOGIN_BY_PASSWORD = 'nhập mật khẩu'

    exports.LOGIN_REGISTER_INPUT_CAPTCHA = 'hãy nhập đoạn bên dưới'

    exports.LOGIN_REGISTER_SWITCH_ROLE = 'cô không có danh t ính sinh viên, cô có muốn mở danh tính sinh viên không?'

    /**
     * =================================================
     * 紧急呼叫（客服电话拨打）
     * =================================================
     */

    exports.CUSTOM_SERVICE_NEED_CALL = 'có chuyện gì sao?gọi cứu viện miễn phí!'

    exports.CUSTOM_SERVICE_CONFIRM_CALL = 'xác nhận cuộc gọi'

    exports.CUSTOM_SERVICE_REJECT_CALL = 'không điện thoại di động'

    exports.CUSTOM_SERVICE_EXTRA_FEE
        = '(một số người dùng có thể tính tiền của những người dịch vụ trả lời điện thoại hay chuyển tiếp do bưu kiện điện thoại)'

    exports.CUSTOM_SERVICE_CALLING = 'Điện thoại hỗ trợ đang gọi.'

    exports.CUSTOM_SERVICE_PICKUP
        = 'xin kết nối<em>nội tạng</em>tùy anh.<br />và chờ người hỗ trợ kỹ thuật phục vụ các bạn.'

    exports.CUSTOM_SERVICE_DAIL = 'gọi trực tiếp trợ giúp'

    exports.CUSTOM_SERVICE_DAIL_CONTENT
        = 'cô có thể tự mình gọi hỗ trợ kỹ thuật.<br />và chờ người hỗ trợ kỹ thuật phục vụ các bạn.<br /><em>bốn tỉ chín trăm mười ngàn chín trăm mười.</em>'

    exports.CUSTOM_SERVICE_AUTO_CLOSE = 'cửa sổ đóng tự động'

    exports.CUSTOM_SERVICE_DIALOG_TITLE = 'giúp dịch vụ khách'

    exports.CUSTOM_SERVICE_QQ_MESSAGE = 'chọn hỗ trợ kỹ thuật để giải quyết vấn đề thời gian thực thông qua qq'

    exports.CUSTOM_SERVICE_QQ_SYSTEM_INFO = 'Hệ thống: {system}, số phiên bản: {system-version}'

    exports.CUSTOM_SERVICE_QQ_BROWSER_INFO = 'Thiết bị đầu cuối: {browser}, số phiên bản: {browser-version}'

    exports.CUSTOM_SERVICE_QQ_PRIMARY = 'hỗ trợ kỹ thuật'

    exports.CUSTOM_SERVICE_QQ_SECONDARY = 'hỗ trợ kỹ thuật'

    /**
     * =================================================
     * 设备变更
     * =================================================
     */

    exports.DEVICE_CHANGE_ADD_AUDIO = 'giọng micro hiện tại đã được chuyển sang thiết bị được cài mới.'

    exports.DEVICE_CHANGE_ADD_VIDEO = 'máy ảnh hiện thời đã được chuyển sang thiết bị vừa được chèn vào.'

    exports.DEVICE_CHANGE_DEL_AUDIO = 'thiết bị điện thoại đã bị rút, chuyển thành thiết bị mặc định'

    exports.DEVICE_CHANGE_DEL_VIDEO = 'máy ảnh đã tháo ra, đã chuyển sang thiết bị mặc định'

    exports.DEVICE_CHANGE_RESET = 'thiết lập nhanh'

    /**
     * =================================================
     * 签到
     * =================================================
     */

    exports.SIGNIN_TITLE_HINT = 'Điểm danh'

    exports.SIGNIN_START = 'tên đầu'

    exports.SIGNIN_STATUS = 'tình hình thế nào?'

    exports.SIGNIN_TIME_NOTICE = 'Vui lòng đặt học sinh trả lời trong vòng ${seconds} giây'

    exports.SIGNIN_ACK_COUNT = '${member} người đã trả lời'

    exports.SIGNIN_NACK_COUNT = '${member} người chưa được trả lời'

    exports.SIGNIN_EXPECT_COUNT = 'sẽ tiếp cận ${member} người'

    exports.SIGNIN_LIST_DOWNLOAD = 'tải về danh sách đầy'

    exports.GROUP_SIGNIN_LIST_DOWNLOAD = 'tải danh sách của nhóm này về'

    exports.SIGNIN_NO_LIST = 'danh sách những người không trả lời'

    exports.SINGIN_NO_NOTICE
        = 'hệ thống hiển thị 50 người chưa trả lời danh sách. Để xem danh sách đầy đủ, xin hãy nhắp vào'

    exports.SIGNIN_AGAIN = 'Điểm danh lần nữa'

    exports.SIGNIN_AGAIN_TIME_NOTICE = 'Cuộc gọi điểm danh có thể được bắt đầu lại sau ${seconds} giây'

    exports.SINGIN_WAIT_TIME_NOTICE
        = 'Học sinh đang trả lời lần lượt, kết quả có thể được xem sau ${seconds} giây, vui lòng đợi'

    exports.SIGNIN_REPLAY = 'câu trả lời là có.'

    exports.SIGNIN_REPLAY_TIME_NOTICE = 'Giáo viên yêu cầu bạn trả lời cuộc gọi trong vòng ${seconds} giây'

    exports.SIGNIN_RESULT_GETTING = 'tổng thống điểm danh'

    exports.SIGNIN_COMPLETE_NOTICE = 'Đã xong phân tích điểm danh'

    exports.SIGNIN_GETTING_RESULT = 'xem kết quả'

    /**
     * =================================================
     * 到课名单
     * =================================================
     */

    exports.JOIN_USERLIST_TITLE_HINT = 'mẹo'

    exports.JOIN_USERLIST_TITLE_LIST = 'danh sách tham dự'

    exports.JOIN_USERLIST_HINT
        = 'danh sách khách mời sẽ ghi lại biệt danh, giờ đến sớm nhất và giờ khởi hành cuối cùng của các học sinh đã đăng ký vào lớp của bạn.<br />học sinh có thời gian ngắn trong lớp học không có trong danh sách.<br />việc tạo ra danh sách có thể gây kẹt,<em>khuyên bạn sử dụng chức năng này sau khi học xong lớp</em>đề:'

    exports.JOIN_USERLIST_COPY_HINT = 'Được tạo thành danh sách.bạn có thể xuất ra một tập tin csv'

    exports.LABEL_CONFIRM = 'xác nhận'

    exports.JOIN_USERLIST_CLOSE = 'đóng'

    exports.JOIN_USERLIST_FETCH = 'tạo danh sách'

    exports.JOIN_USERLIST_FETCHING = 'xây'

    exports.JOIN_USERLIST_STUDENT_ID = 'thẻ sinh viên'

    exports.JOIN_USERLIST_STUDENT_NAME = 'biệt danh sinh viên'

    exports.JOIN_USERLIST_LOGIN_TIME = 'thời gian gần nhất'

    exports.JOIN_USERLIST_LOGOUT_TIME = 'giờ khởi hành cuối'

    exports.JOIN_USERLIST_GROUP = 'tên nhóm'

    exports.JOIN_USERLIST_ENDTYPE = 'kiểu cuối'

    exports.JOIN_USERLIST_COPY = 'xuất'

    exports.JOIN_USERLIST_STILL_IN = 'không đi'

    exports.JOIN_USERLIST_NOBODY_HINT = 'hiện tại không có sinh viên nào trong lớp.'

    /**
     * =================================================
     * 助教链接
     * =================================================
     */

    exports.ASSISTANT_LINK = 'liên kết với giảng viên'

    exports.ASSISTANT_LINK_NEW_HINT
        = '[cập nhật mới nhất] giảng viên có thể dùng<em>khách</em>bản ghi tại... cuộn ghi tại... cuộn video 6588;mục: trang đăng nhập khách (góc dưới phải)'

    exports.ASSISTANT_LINK_HINT
        = 'chép và gửi liên kết trợ lý dạy học cho người bạn nhỏ. anh có thể trở thành trợ lý dạy học và vào trực tiếp lớp học.<br />và có học sinh quản lý để nói, không cho học sinh nói, giúp ghi lại lớp và nhiều nhà chức trách.'

    exports.ASSISTANT_LINK_LABEL_NAME = 'tên của trợ lý dạy:'

    exports.ASSISTANT_LINK_LABEL_AVATAR = 'chọn avatar đi.'

    exports.ASSISTANT_LINK_DEFAULT_NAME = 'trợ'

    exports.ASSISTANT_LINK_NAME_MAXLENGTH = 'tên không quá tám từ'

    exports.ASSISTANT_LINK_NAME_EMPTY = 'xin hãy nhập tên của trợ lý dạy.'

    exports.ASSISTANT_LINK_SUCCESS = 'kết nối của trợ lý dạy thành công, xin giữ bí mật!'

    exports.ASSISTANT_LINK_COPY_SUCCESS = 'kết nối thành công'

    exports.ASSISTANT_LINK_FAILURE = 'liên kết sai của ta'

    /**
     * =================================================
     * 课件缩放工具条
     * =================================================
     */

    exports.DOC_QUALITY_LOW = 'chất lỏng: sử dụng các loại thuốc nén, lật trang này nhanh hơn.'

    exports.DOC_QUALITY_HIGH = 'tranh gốc: các bài đệ đều rõ ràng, nhưng<em>dễ bị kẹt</em>đề:'

    exports.DOC_FIT_VIEW = 'chỉnh'

    exports.DOC_FIT_WIDTH = 'điền'

    exports.ALLOW_STUDENT_CHANGE_PPT = 'cho phép: cho phép học sinh lật trang.'

    exports.FORBID_STUDENT_CHANGE_PPT = 'cấm học sinh lật trang.'

    exports.HIDDEN_REMARKINFO = 'Ẩn: không hiển thị đoạn ghi chú nội bộ pppd.'

    exports.SHOW_REMARKINFO = 'hiển thị: hiển thị đoạn ghi chú nội bộ pppd.'

    /**
     * =================================================
     * 系统检测工具
     * =================================================
     */

    exports.DETECT_TOOL_DIALOG_TITLE = 'hệ thống dò'

    exports.DETECT_TOOL_CUSTOM_SERVICE = 'yêu cầu hỗ trợ kỹ thuật'

    exports.DETECT_TOOL_TIPS = 'Đề nghị giải pháp:'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_GOOD = 'lớp - mịn tuyệt vời'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_OK = 'thỉnh thoảng có mèo'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_NORMAL = 'mắc kẹt thường xuyên'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_BAD = 'tệ quá- không có lớp'

    exports.DETECT_TOOL_NET_STATUS_GOOD = 'mạng tốt'

    exports.DETECT_TOOL_NET_STATUS_OK = 'mạng chung'

    exports.DETECT_TOOL_NET_STATUS_POOR = 'mạng kém'

    exports.DETECT_TOOL_NET_STATUS_TERRIBLE = 'internet không hay đâu.'

    exports.DETECT_TOOL_NET_STATUS_DETECT = 'phát hiện kết nối mạng'

    exports.DETECT_TOOL_NET_STATUS_DETECTING = 'phát hiện mạng'

    exports.DETECT_TOOL_NET_STATUS_TIPS_HEADER = 'nếu mạng không tốt, xin hãy thử các phương pháp sau:'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CLOSE_P2P
        = 'tắt sét và các phần mềm p2p, và dùng cáp truyền hình để kết nối máy tính.'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CHECK_LAN
        = 'hãy kiểm tra xem có người dùng nào khác sử dụng một lượng lớn độ rộng băng trong mạng lan'

    exports.DETECT_TOOL_NET_STATUS_TIPS_REBOOT = 'khởi chạy lại máy tính và bộ định tuyến'

    exports.DETECT_TOOL_NET_STATUS_NO_RESULT = 'không có thông tin đo tốc độ hay mạng ngắt kết nối, nhắc lại'

    exports.DETECT_TOOL_HELP_NET = 'liên lạc'

    exports.DETECT_REFRESH_NOTICE = 'không thể liên lạc với lớp học?bạn có thể tắt mạng và cố gắng tải lại~'

    exports.DETECT_NET_PROGRAM_REFRESH_NOTICE = 'nối lại, xin đợi.'

    exports.DETECT_TOOL_REDETECT = 'thử'

    exports.DETECT_TOOL_SPEAKER_DETECT = 'phát hiện ngôn ngữ'

    exports.DETECT_TOOL_SPEAKER_INITIATING = 'phát ngôn ngữ'

    exports.DETECT_TOOL_SPEAKER_TEST_SOUND_PLAYING = 'diễn thử âm nhạc'

    exports.DETECT_TOOL_SPEAKER_HAVE_YOU_HEARD = 'anh có nghe âm thanh thử nghiệm không?'

    exports.DETECT_TOOL_SPEAKER_NO_DEVICE = 'phát hiện thiết bị loa'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHECK_PLUG = 'xem kết nối loa có bình thường hay không'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_DEVICE = 'thiết bị chuyển loa'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME = 'Điều chỉnh âm lượng loa'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME_OUTER = 'Điều chỉnh nút âm lượng loa ngoài'

    exports.DETECT_TOOL_SPEAKER_TIPS_OS_SETTING
        = 'mở<span class="os-setting-trigger">tổ chức phát ngôn</span>xem có tắt loa không'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_MAC = 'mở<em>Ứng dụng hệ thống</em>thiết lập loa'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_WINDOWS
        = 'mở<em>bắt đầu bật/ ban điều khiển âm thanh</em>xem có tắt loa không'

    exports.DETECT_TOOL_HELP_SPEAKER = 'chủ tịch faq.'

    exports.DETECT_TOOL_MIC_DETECT = 'phát hiện điện thoại'

    exports.DETECT_TOOL_MIC_DETECTING = 'xin hãy nói vào mícrô.'

    exports.DETECT_TOOL_MIC_DETECTING_TIPS = 'khi nói chuyện, bạn nên đeo tai nghe và tắt loa để tránh siêu âm'

    exports.DETECT_TOOL_MIC_HAS_INPUT = 'phát hiện âm thanh'

    exports.DETECT_TOOL_MIC_HAS_INPUT_WARNING = 'tốt nhất là tắt loa ngoài và đeo tai nghe để tránh huýt sáo và vọng'

    exports.DETECT_TOOL_MIC_NO_INPUT = 'phát hiện không xuất âm thanh'

    exports.DETECT_TOOL_MIC_NO_DEVICE = 'phát hiện thiết bị không nghe lén'

    exports.DETECT_TOOL_MIC_TIPS_HEADER = 'nếu có thắc mắc gì, xin hãy thử các phương pháp theo đây:'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_VOLUME = 'Điều chỉnh âm thanh'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_DEVICE = 'thiết bị xoay micro'

    exports.DETECT_TOOL_MIC_TIPS_HEADER_UNDETECTED = 'thử như sau:'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_PLUG = 'kiểm tra nếu kết nối míc bình thường và được bật.'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_BLOCK
        = 'kiểm tra xem trình duyệt và phần mềm quản lý máy tính có chặn việc sử dụng thiết bị không'

    exports.DETECT_TOOL_MIC_TIPS_OS_SETTING
        = 'mở<span class="os-setting-trigger">thiết lập micro</span>xem có tắt micro không.'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_MAC = 'mở<em>name of translators</em>thiết lập microphone'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_WINDOWS
        = 'mở<em>bắt đầu ghi âm âm âm (mục) trong bảng điều khiển</em>xem có tắt micro không.'

    exports.DETECT_TOOL_HELP_MIC = 'liên kết điện thoại'

    exports.DETECT_TOOL_CAMERA_DETECT = 'phát hiện máy ảnh'

    exports.DETECT_TOOL_CAMERA_HAS_CAMERA = 'anh có thấy hình ảnh không?'

    exports.DETECT_TOOL_CAMERA_NO_CAMERA = 'không phát hiện thiết bị ảnh'

    exports.DETECT_TOOL_CAMERA_TIPS_HEADER = 'nếu bạn không thấy ảnh, hãy thử vào:'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_PLUG = 'kiểm tra xem máy ảnh có kết nối đúng không'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_CLOSE_OTHER
        = 'xin hãy cố đóng những chương trình khác có thể chiếm lấy máy ảnh.'

    exports.DETECT_TOOL_CAMERA_TIPS_CHANGE_DEVICE = 'thiết bị ảnh'

    exports.DETECT_TOOL_CAMERA_TIPS_OS_SETTING = 'thiết lập máy ảnh'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_MAC
        = 'ở<em>món táo (apple) về máy ảnh này..., xem thử (siÊu) báo cáo hệ thống (Ấn Độ) máy ảnh (usb)</em>kiểm tra xem thiết bị camera có được cài đặt thường xuyên trong'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_WINDOWS
        = 'ở<em>chạy ban điều khiển Đối tượng</em>kiểm tra xem thiết bị camera có được cài đặt thường xuyên trong'

    exports.DETECT_TOOL_HELP_CAMERA = 'máy ảnh faq'

    exports.DETECT_TOOL_FINISH = 'kiểm tra hệ thống'

    exports.DETECT_TOOL_FINISH_TIPS
        = 'nếu hệ thống vẫn gặp vấn đề, xin hãy cố gắng khởi động lại khách hàng, máy tính và bộ định tuyến, hoặc hỗ trợ kỹ thuật liên lạc.'

    /**
     * =================================================
     * settings
     * =================================================
     */

    exports.SETTINGS_MIC_PREFERENCE_SCALING = 'mic boost.'

    exports.SETTINGS_MIC_PREFERENCE_SCALING_UNIT = 'dgenericname'

    exports.SETTINGS_TIP_DETECT_CLOSE = 'Thiết bị phát hiện sẽ đóng ${services}, bạn có muốn tiếp tục không?'

    exports.SETTINGS_INFO_TIP_OPEN_CAMERA = 'Để học đoạn video, xin hãy nhắp vào để mở máy ảnh.'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_CAMERA_FORBIDDEN
        = 'chương trình này là một lộ trình trực tiếp âm thanh, và máy ảnh không được phép'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_SCREEN_SHARE_FORBIDDEN
        = 'chương trình này là một lộ trình trực tiếp âm thanh, và chức năng chia sẻ màn hình không được phép.'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_MEDIA_PLAY_FOBIDDEN
        = 'chương trình này là một lộ trình trực tiếp âm thanh, và tập tin video không thể được bật.'

    /**
     * =================================================
     * 媒体服务器切换后的相关提示
     * =================================================
     */

    exports.SWITCH_TIP_CLOSE_CAMERA
        = 'nó được phát hiện rằng mạng lưới của bạn thay đổi rất nhiều và sự mất tập tin rất nghiêm trọng. bạn có thể cố tắt đoạn video để giảm sự cố vết mẻ'

    exports.SWITCH_TIP_SWITCH_CDN
        = 'nó được phát hiện rằng mạng lưới của bạn thay đổi rất nhiều và sự mất tập tin rất nghiêm trọng. bạn có thể thử đổi dòng để giảm thanh mứt.'

    exports.SWITCH_TIP_QUALITY
        = 'nó được phát hiện rằng mạng lưới của bạn thay đổi rất nhiều và sự mất tập tin rất nghiêm trọng. hãy giảm định nghĩa để giảm sự cố.'

    exports.SWITCH_TIP_NET_STATUS
        = 'nó được phát hiện rằng mạng lưới của bạn thay đổi rất nhiều và sự mất bao thư là nghiêm trọng. xin kiểm tra điều kiện mạng'

    exports.SWITCH_TIP_TEACHER_NET_STATUS
        = 'các kênh bên giáo viên thay đổi rất nhiều, và đôi khi sẽ có hiện tượng bị kẹt.'

    /**
     * =================================================
     * 底部操作 class ation 相关
     * =================================================
     */
    exports.CLASS_ACTION_TIP_DOWNLOAD_WINDOWS
        = 'chỉ có khách hàng mới được giơ tay.'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=windows" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD_MAC
        = 'chỉ có khách hàng mới được giơ tay.'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=mac" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD
        = 'chỉ có khách hàng mới được giơ tay.'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载'

    /**
     * =================================================
     * 进入教室过程中的提示
     * =================================================
     */

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECTING = 'kết nối tới máy chủ chính'

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECT_SUCCESS = 'máy chủ đã kết nối'

    exports.ENTER_CLASSROOM_SERVER_INFO_FETCH_SUCCESS = 'thông tin mật'

    exports.ENTER_CLASSROOM_ROOM_SERVER_CONNECT_SUCCESS = 'máy chủ hạng nhất kết nối'

    exports.ENTER_CLASSROOM_ROOM_SERVER_LOGIN_SUCCESS = 'duyệt hệ thống mật'

    exports.ENTER_CLASSROOM_AUTH_TOKEN_FAIL = 'người dùng bất hợp pháp'

    exports.ENTER_CLASSROOM_OVERMAN = 'phòng đã đầy, hãy thử lại sau.'

    exports.ROOM_SERVER_LOGIN_CONFLICT_CONFIRM
        = 'Đã có một giáo viên trong lớp. bước vào sẽ làm cho giáo viên bỏ lớp học. bạn có muốn tiếp tục tham gia không?'

    /**
     * =================================================
     * 新手引导相关话术
     * =================================================
     */

    exports.USER_GUIDE_DOWNLOAD_TEACHER
        = 'sử dụng thân chủ để dạy, âm thanh và video thông thạo hơn, và chức năng dạy học thì giàu hơn.'
        + '你还等什么？快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    exports.USER_GUIDE_DOWNLOAD_STUDENT
        = 'dùng thân chủ để nghe âm thanh và video thành thạo hơn. bọn trẻ đang sử dụng nó. còn chờ gì nữa?'
        + '快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    /**
     * =================================================
     * 服务器重连提示
     * =================================================
     */

    exports.RECONNECT_ROOM_SERVER_WAITING = 'mạng không được mạnh, xin hãy kiểm tra mạng'

    exports.RECONNECT_ROOM_SERVER_SUB_WAITING = 'Đang cố kết nối'

    exports.ROOM_SERVER_LOGIN_EXPIRED_TIP = 'lớp học đã hết hạn'

    /**
     * =================================================
     * 录制课程
     * =================================================
     */

    exports.RECORD_CLASS_REMIND = 'Âm thanh bị gián đoạn, hãy nhắp lần nữa'

    exports.RECORD_INFO_TIP = 'nó đề nghị bắt đầu ghi âm lớp và tải hồi âm sau lớp học.'

    exports.RECORD_COMPLETE_TIP = 'Đã ghi lại khóa<span class="btn-action">mở tập tin lưu hạng cục bộ</span>'

    exports.RECORD_STOPPING_TIP = 'Đang tạo tệp ghi âm cục bộ, vui lòng đợi...'

    exports.RECORD_RESTART_TIP = 'máy thu âm đã ngừng. hãy thử lại<span class="btn-action">mở</span>thu âm cục'

    /**
     * =================================================
     * 自动录课
     * =================================================
     */

    exports.AUTO_RECORD_START = 'tất cả sẽ tự động chạy'

    exports.AUTO_RECORD_RESTART = 'tất cả sẽ được mở lại'

    exports.AUTO_RECORD_STOP
        = 'chương trình đã bị dừng lại và có thể được tải lên các học viên trong khách hàng để xem lại'

    exports.AUTO_RECORD_CLASS_COUNT_DOWN_TIP = 'tự động mở theo giây'
    exports.AUTO_RECORD_CANCEL = 'hủy ghi âm'
    exports.AUTO_RECORD_LATER = 'nhắc lại sau.'

    exports.AUTO_RECORD_MODE_CLOUD_AND_LOCAL = 'mây- cục bộ'

    exports.AUTO_RECORD_MODE_CLOUD = 'mây.'

    exports.AUTO_RECORD_MODE_LOCAL = 'địa'

    exports.AUTO_RECORD_REASON = 'bài học này được thiết lập để quay lại khi bài học bắt đầu'

    exports.AUTO_RECORD_TIP_NET_DISK_EMPTY
        = 'không gian lưu dữ liệu đầy, không thể ghi lại trong đám mây. vui lòng bắt đầu ghi âm lại sau khi mở rộng khả năng.'

    exports.NO_RECORD_WHEN_AUTO_RECORD
        = 'hệ thống phát hiện việc ghi âm đám mây không được bật. bạn có muốn bật khả năng ghi âm đám mây không?'

    /**
     * =================================================
     * 环境监测
     * =================================================
     */

    exports.ENV_DETECT_HEADER = 'tăng tốc mạng'

    exports.ENV_DETECT_ACTION = 'chỉ cần nhấn mạnh'

    exports.ENV_DETECT_KILLING = 'tăng'

    exports.ENV_DETECT_KILL_COMPLETE = 'dùng tốt'

    exports.ENV_DETECT_PROCESS = 'Đề nghị kết thúc'

    /**
     * =================================================
     * CDN 厂商名称
     * =================================================
     */

    exports.CDN_DNION = 'quân minh'

    exports.CDN_NET_CENTER = 'hoãn trực tiếp'

    exports.CDN_CHINA_CACHE = 'lan xu'

    /**
     * =================================================
     * 录制
     * =================================================
     */

    exports.RECORD_COLLECTS_LOCAL_RECORD = 'thu âm cục'

    exports.RECORD_COLLECTS_CLOUD_RECORD = 'thu âm mây'

    exports.RECORD_COLLECTS_ALL_RECORD = 'việc ghi âm samba cục bộ'

    exports.RECORD_COLLECTS_CLOUD_RECORD_LIST = 'quản lý quay phim mây'

    exports.RECORD_COLLECTS_PRE_START_INFO = 'hãy bắt đầu ghi âm lại lộ trình.'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME
        = 'Đã hết thời gian cuối khóa học, chỉ có ghi âm cục bộ mới được dùng.'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_WEB
        = 'Đã hết thời gian cuối khóa học, nó không thể lưu lại trong đám mây.'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_PAUSE
        = 'khoảng thời gian kết thúc của dòng chảy đã vượt qua 15 phút. sau khi ghi âm đám mây bị đình chỉ, nó sẽ kết thúc tự động. bạn có muốn chấm dứt không?'

    exports.RECORD_COLLECTS_CLOUD_RECORD_PAUSING_OVER_TIME
        = 'nếu đoạn ghi âm không được tiếp tục diễn trong vòng lăm phút sau khi lộ trình kết thúc, đoạn ghi âm đám mây sẽ tự động kết thúc. xin chú ý.'

    exports.CLOUD_RECORD_OVER_TIME_WARNING_INFO_BTN = 'Được rồi!'

    exports.END_RECORD_COLLECTS_PAUSE_RECORD = 'đình'

    exports.END_RECORD_COLLECTS_STOP_RECORD = 'thôi đi.'

    exports.END_RECORD_THEN = 'hiện tại chưa tạo ra'

    exports.END_RECORD_START_PLAYBACK = 'xây nhà'

    exports.ALERT_STOP_PUSH_RECORD = 'cô có muốn kết thúc đoạn ghi âm màn hình không?'

    /**
     * =================================================
     * 录课设置
     * =================================================
     */

    exports.RECORD_SETTINGS_TITLE = 'Đặt lộ trình ghi âm'

    exports.RECORD_SETTINGS_AUTO_START = 'mở tự động sau lớp'

    exports.RECORD_SETTINGS_AUTO_START_LOCAL = 'thu âm cục'

    exports.RECORD_SETTINGS_AUTO_START_CLOUD = 'thu âm mây'

    exports.RECORD_SETTINGS_RECORD_MODE = 'chế độ ghi đường'

    exports.RECORD_SETTINGS_RECORD_MODE_PART = 'thu âm cửa sổ'

    exports.RECORD_SETTINGS_RECORD_MODE_FULLSCREEN = 'máy ghi toàn màn hình'

    exports.RECORD_SETTINGS_PATH = 'lưu đoạn băng ghi âm cho bài học'

    // exports.RECORD_SETTINGS_REMEMBER = '记住选择（可到“更多 - 录课设置”中修改）';

    exports.RECORD_SETTINGS_LOCATION_TIP = 'nó có thể được sửa đổi trong "nhiều thiết lập ghi âm"'

    /**
     * =================================================
     * 云端录制
     * =================================================
     */

    exports.CLOUD_RECORD_CONFIRM_START
        = 'bạn có muốn bắt đầu ghi âm lớp mây và tự động tạo ra đoạn chơi sau lớp không?<br />(hiện thời, ghi âm đám mây không được hỗ trợ trong lớp)'

    exports.CLOUD_RECORD_START_TIP_SDK
        = 'việc ghi âm đám mây được ghi trực tiếp trên máy phục vụ đám mây, và đoạn ghi âm cục bộ không được lưu.<br />'
        + 'chương trình sẽ tự động bật ra sau mười phút sau khi lộ trình kết thúc.<br />'

    exports.PUSH_RECORD_START_TIP_SDK
        = 'Đoạn ghi âm chụp màn hình cần giữ thân chủ mở và to àn bộ màn hình.<br />'
        + 'tập tin ghi âm lộ trình không được lưu cục bộ, và đoạn được bật lại sẽ tự động tạo ra mười phút sau khi lộ trình kết thúc.<br />'
        + 'vấn đề cần chú ý:<br />'
        + '    1. xin đừng tắt loa ở cuối đoạn ghi âm, nếu không sẽ không có âm thanh được ghi lại.<br />'
        + '    2. xin đừng đưa thân chủ ra khỏi cửa sổ ghi âm, nếu không phần gỡ bỏ của đoạn ghi âm sẽ hiển thị màn hình màu đen;'

    exports.ALERT_PUSH_RECORD_NETWORK_ERROR = 'vì có thể ngắt kết nối, hãy kiểm tra mạng và thử lại'

    exports.CLOUD_RECORD_OVERTIME_STOP_TIP
        = 'vòng cuối đã vượt qua tám tiếng, và máy ghi âm đám mây sẽ tự động dừng lại.'

    exports.CLOUD_RECORD_PRE_START_TIP = 'bắt đầu ghi âm đám mây và tự động tạo lại'

    exports.CLOUD_RECORD_OVERTIME_TIP = 'sau khi kết thúc lộ trình, bạn không thể mở đoạn ghi âm đám mây.'

    exports.CLOUD_RECORD_RESTART_TIP
        = 'nếu bạn cần tạm dừng ghi âm trong lớp, bạn có thể nhắp vào nút ngừng ghi âm, và nhắp vào lần nữa ghi âm khi bạn cần tiếp tục.'

    exports.CLOUD_RECORD_WITHOUT_TEACHER_WARNING
        = 'thầy giáo không ở trong phòng trực tiếp. không được bắt đầu ghi âm đám mây.'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGININ_SUCCESS = 'câu trả lời là thành công.'

    /**
     * =================================================
     * 磁盘空间
     * =================================================
     */

    exports.NET_DISK_INFO_TITLE = 'mẹo'

    exports.NET_DISK_INFO_BTN = 'Được rồi!'

    exports.NET_DISK_INFO_POOR_PREFFIX = 'kho chứa đám mây của bạn có hạn'

    exports.NET_DISK_INFO_POOR_SUFFIX
        = 'mb, khi nào có đủ khoảng trống thì bạn sẽ không thể tải những dòng này lên được<a target="_blank" href="/teacher_center/storage_space">mua</a>thêm khoảng trống đám mây hoặc<a target="_blank" href="/teacher_center/netdisk">rõ</a>tập tin vô dụng'

    exports.NET_DISK_INFO_POOR_WRITE_PREFFIX = 'kho chứa đám mây của bạn có hạn'

    exports.NET_DISK_INFO_POOR_WRITE_SUFFIX = 'mlb, sẽ không dùng ghi âm đám mây,'

    exports.NET_DISK_INFO_EMPTY
        = 'bạn không thể tải các trường dòng lên chưa đủ, xin hãy tải ngay.<a target="_blank" href="/teacher_center/storage_space">mua</a>thêm khoảng trống đám mây hoặc<a target="_blank" href="/teacher_center/netdisk">rõ</a>tập tin vô dụng'

    exports.NET_DISK_INFO_EMPTY_WRITE_PREFFIX = 'không gian chứa mây của bạn đã vượt quá giới hạn'

    exports.NET_DISK_INFO_EMPTY_WRITE_SUFFIX = 'mlb, sẽ không dùng ghi âm đám mây,'

    exports.NET_DISK_INFO_EXCEED_WRITE_PREFFIX = 'không gian chứa mây của bạn đã vượt quá giới hạn'

    exports.NET_DISK_INFO_EXCEED_WRITE_SUFFIX = 'mb, không còn khả năng ghi âm đám mây'

    /**
     * =================================================
     * 用户列表更多选项按钮
     * =================================================
     */

    exports.MORE_SETTINGS_BUTTON_FORBID_SEND_MESSAGE = 'không chat'

    exports.MORE_SETTINGS_BUTTON_UNFORBID_SEND_MESSAGE = 'cho phép chat'

    /**
     * =================================================
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'giao dịch phát từ đảng ba'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'hướng dẫn rtmp:'
    exports.LABLE_SERVER_STATUS_NORMAL = 'truyền thông bình thường.'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'gởi dữ liệu âm thanh'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'nhấn mạnh dịch vụ'
    exports.LABLE_SERVER_STATUS_PREPARING = 'Đang sửa chữa'

    exports.BUTTON_REFRESH_LIST = 'cập nhật danh sách'
    exports.BUTTON_COPY_URI_OF_SERVER = 'rõ'
    exports.BUTTON_RESTART_SERVER = 'khởi chạy dịch vụ'
    exports.BUTTON_START_TRANPONDING_STREAM = 'chạy tiếp'
    exports.BUTTON_STOP_TRANPONDING_STREAM = 'dừng lại'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'tên dòng'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'mã video'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = 'quyết định video'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = 'mã âm thanh'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = 'lấy mẫu âm thanh'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = 'bang'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'không có dữ liệu'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = 'truyền'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'tôi sẽ không ủng hộ.'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = 'chưa chuyển'

    exports.RESTART_SERVER_FAILED_TIP = 'phục vụ khởi động bị lỗi'
    exports.COPY_SUCCESS_TIP = 'chép thành công'
    exports.PUSH_STREAM_FAILED_TIP = 'nguồn cung cấp hỏng'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'không thể lấy địa chỉ máy chủ'

    exports.STREAM_INFO_MARK_IS_TRANSPONDING = 'quay'

    exports.INFO_NO_DATA_FROM_STREAM
        = 'không có dữ liệu trong dòng chảy bên ngoài. xin kiểm tra thiết bị và mạng, hoặc khởi động lại dịch vụ.'

    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'màu trắng'
    exports.ASSIST_CAMERA = 'máy ảnh phụ'
    exports.SCREEN_SHARE = 'chia màn hìnhname'

    exports.CLOSE_MEDIA_BEFORE_DETECT = 'Đừng bật các tập tin ảnh và âm thanh trước.'
    exports.CLOSE_DESKTOP_SHARE_BEFORE_DETECT = 'xin hãy tắt bộ chia sẻ màn hình trước'

    exports.SETTING_CAMERA_DISABLE = 'máy ảnh được sử dụng, thiết lập không thể thay đổi tạm thời'
    exports.SETTING_ASSIST_CAMERA_DISABLE = 'máy ảnh phụ trợ đang được sử dụng, thiết lập không thể thay đổi tạm thời'
    exports.SETTING_SHARE_DISABLE = 'chia sẻ màn hình đang được dùng, không thể thay đổi thiết lập tạm thời'

    /**
     * =================================================
     * 邀请发言
     * =================================================
     */
    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INIT = 'mời lúa mì'

    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INVITING = 'hủy giấy mời'

    exports.MORE_SETTINGS_MARK_INVITING = 'mời vào'

    exports.MORE_SETTINGS_MARK_SPEAKING = 'nói'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_INIT = 'lúa mì ép'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_OPENING = 'mở'

    exports.MORE_SETTINGS_BUTTON_SPEAK_INVITE_UNSUPPORTED_HOVER_TIP
        = 'người dùng dùng phiên bản web và không hỗ trợ việc mời mac'

    exports.BUTTON_OPEN_WEBCAM = ' bật máy ảnh lên. '

    /**
     * =================================================
     *
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = 'giao dịch phát từ đảng ba'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'hướng dẫn rtmp:'
    exports.LABLE_SERVER_STATUS_NORMAL = 'truyền thông bình thường.'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = 'gởi dữ liệu âm thanh'
    exports.LABLE_SERVER_STATUS_ABNORMAL = 'nhấn mạnh dịch vụ'

    exports.BUTTON_COPY_URI_OF_SERVER = 'rõ'
    exports.BUTTON_RESTART_SERVER = 'khởi chạy dịch vụ'
    exports.BUTTON_START_TRANPONDING_STREAM = 'chạy tiếp'
    exports.BUTTON_STOP_TRANPONDING_STREAM = 'dừng lại'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = 'tên dòng'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = 'mã video'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = 'quyết định video'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = 'mã âm thanh'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = 'lấy mẫu âm thanh'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = 'bang'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = 'không có dữ liệu'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = 'truyền'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = 'tôi sẽ không ủng hộ.'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = 'chưa chuyển'

    exports.RESTART_SERVER_FAILED_TIP = 'phục vụ khởi động bị lỗi'
    exports.COPY_SUCCESS_TIP = 'chép thành công'
    exports.PUSH_STREAM_FAILED_TIP = 'nguồn cung cấp hỏng'
    exports.CAN_NOT_GET_SERVER_URL_TIP = 'không thể lấy địa chỉ máy chủ'
    exports.STREAM_INFO_MARK_IS_TRANSPONDING = 'quay'
    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = 'màu trắng'
    exports.ASSIST_CAMERA = 'máy ảnh phụ'
    exports.SCREEN_SHARE = 'chia màn hìnhname'

    exports.SIGNIN_FORBID
        = 'lần điểm danh tiếp theo chỉ có thể khởi động một phút sau lần điểm danh cuối cùng đếm ngược.'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGNIN_FORBID
        = 'lần điểm danh tiếp theo chỉ có thể khởi động một phút sau lần điểm danh cuối cùng đếm ngược.'

    exports.BEGIN_EXAM_TIP = 'anh có chắc là sẽ mở bài kiểm tra không?'

    exports.END_EXAM_TIP = 'anh chắc là sẽ kết thúc bài kiểm tra chứ?'

    exports.BEGIN_EXAM_INFO = 'cuộc thi mở cửa'

    exports.END_EXAM_INFO = 'cuộc thi vào cửa đã bị đóng cửa.'

    exports.UNKNOW_EMOTION = '[giọng lạ]'

    /**
     * =================================================
     * 升级浏览器提示
     * =================================================
     */
    exports.UPGRADE_CLOSE_POWER_SAVING_MODE = 'tắt chế độ tiết kiệm năng lượng'

    exports.UPGRADE_NOTICE_SAFARI
        = 'bạn đang sử dụng trình duyệt safari, xin hãy chắc chắn tắt chế độ tiết kiệm sức mạnh để đảm bảo lớp học thông thường của audio và video'

    exports.UPGRADE_SAFARI_SETTING = 'thiết lập safari'

    exports.UPGRADE_CANCEL_CHECK = 'ngừng'

    exports.UPGRADE_NOTICE_NO_FLASH
        = 'hệ thống phát hiện bộ phận flash của bạn không hoạt động đúng cách, điều đó sẽ làm cho chức năng phòng học không hoạt động đúng cách.<br />xin hãy thử chơi đoạn video bên dưới. nếu bạn không thể chơi nó, xin hãy t ải nó về.'

    exports.UPGRADE_BROWSER_GOOGLE = 'trình duyệt google'

    exports.UPGRADE_FAIL_CONTACT_TEL
        = 'nếu vấn đề không giải quyết được, hãy liên lạc với dịch vụ khách hàng 4000-910-910'

    exports.UPGRADE_CLOSE_POWER_SAVING_MODE_CHROME
        = 'bạn đang sử dụng phiên bản mới nhất của trình duyệt chrme. hãy tắt chế độ tiết kiệm năng lượng để đảm bảo rằng âm thanh và video có thể được dùng bình thường.'

    exports.UPGRADE_CHROME_SETTING_STEP_ONE = 'hãy nhập trang thiết lập kết dính crom'

    exports.UPGRADE_CHROME_SETTING_STEP_TWO = 'kiểm tra luôn cho phép adobe flash player chạy'

    exports.UPGRADE_REFRESH_LIVE_ROOM = 'cập nhật trang phòng'

    exports.UPGRADE_NO_FLASH_CAN_NOT_START = 'trình duyệt của bạn không được cài nút flash, sẽ không thể cho lớp chuẩn'

    exports.UPGRADE_INSTALL_GUIDE = 'hướng dẫn lắp'

    exports.UPGRADE_TAKE_A_LOOK = 'hãy xem qua trước đã.'

    exports.UPGRADE_NOTICE_TO_LOW_BROWSER
        = 'rất khó cho trình duyệt của bạn trải nghiệm các chức năng quyền lực của lớp học trực tuyến. nó được khuyên thay thế trình duyệt cấp cao.'

    exports.UPGRADE_ENABLE_NEW_TECH = 'sử dụng công nghệ tối tân'

    exports.UPGRADE_BY_REJECT = 'hãy làm cho nó hoạt động.'

    exports.FLASH_CAN_NOT_USE = 'trình tải phần flash mạng bị lỗi, bạn có thể thử hoạt động theo đây'

    exports.CLICK_ALLOW_TIP = 'và chọn « cho phép » trên dấu nhắc'

    exports.CLICK_INSTALL_TIP = 'và cài đặt'

    exports.CLICK_TIP = 'nhắp'

    exports.ALLOW_FLASH = 'bật/ tắt'

    exports.DOWNLOAD_FLASH = 'tải về'

    /**
     * =================================================
     * 管理课件
     * =================================================
     */

    exports.DOCUMENT_UPLOAD = 'tải về'

    exports.DOCUMENT_UPLOAD_ING = 'thương lượng đang tải'

    exports.DOCUMENT_UPLOAD_FROM_NETDISK = 'thêm từ cơ sở dữ liệu'

    exports.DOCUMENT_HAS_ADD = 'thêm ví'

    exports.DOCUMENT_SUPPORT_FORMAT = 'hỗ trợ ppt, pppd, doc, docx, jpg, png, pdf'

    exports.DOCUMENT_MOVE_UP = 'di chuyển lên'

    exports.DOCUMENT_MOVE_DOWN = 'Đi xuống'

    exports.DOCUMENT_UPLOAD_STAUS_CACEL = 'hủy tải'

    exports.DOCUMENT_UPLOAD_STAUS_ING = 'gửi'

    exports.DOCUMENT_UPLOAD_STAUS_FAIL = 'lỗi tải lên'

    exports.DOCUMENT_TRANSFORM_STATUS_FAIL = 'lỗi dịch'

    exports.DOCUMENT_TRANSFORM_STATUS_WAIT = 'Đang đợi mã hóa'

    exports.DOCUMENT_TRANSFORM_ING = 'dịch'

    exports.DOCUMENT_HAS_ADD_STATUS = 'thêm'

    exports.DOCUMENT_TRANSFORM_NOTICE = 'vì những tài liệu được soạn bởi wbs, hãy chuyển đổi thành pdf và tải chúng lên'

    exports.DOCUMENT_DEMO_LINK = 'nhấn vào đây để xem hướng dẫn chuyển đổi'

    exports.DOCUMENT_CAN_USE_STATUS = 'mở'

    exports.DOCUMENT_HAS_BE_CHECKED = 'chọn'

    exports.DOCUMENT_UPLOAD_ING_NOTICE = 'tập tin đang được tải lên, xin hãy đợi.'

    exports.DOCUMENT_MANAGEMENT = 'quản lý rắn'

    exports.DOCUMENT_BACK_TO_MANAGEMENT = 'return to courses management'

    exports.SURVEY_PLEASE_INPUT_ANSWER = 'xin hãy nhập câu trả lời.'

    exports.PLACEHOLDER_NOITCE_CONTENT = 'hãy nhập vào nội dung chính của thông báo.'

    exports.PLACEHOLDER_NOITCE_LINK = 'hãy nhập vào đường dẫn thông báo (tùy chọn)'

    exports.PLACEHOLDER_NOITCE_GROUP_CONTENT = 'hãy nhập vào văn bản của thông báo.'

    exports.PLACEHOLDER_NOITCE_GROUP_LINK = 'hãy nhập mã nhảy thông báo (tùy chọn)'

    exports.NOTICE_LINK_ERROR_HINT = 'Định dạng liên kết sai'

    exports.KICK_OUT = 'có chuyện đột ngột!'

    exports.ENTER_CLASSROOM_KICKED_OUT = 'sau khi được mời ra khỏi lớp, bạn không thể vào lớp lần nữa.'

    exports.KICKED_OUT_TIP = 'các bạn đã được mời ra khỏi lớp'

    exports.KICKED_OUT_BY_AUDITION_END_TIP
        = 'Đã hết giờ thử vai, nếu bạn muốn tiếp tục học lớp, hãy đăng ký và tham gia!'

    exports.KICKED_OUT_BY_ROOM_DISABLED_TIP
        = 'phòng trực tiếp hiện tại đã bị tắt bạn đã được mời ra khỏi phòng trực tiếp'

    exports.ALERT_KICK_OUT_AFTER_CLASS_30_MINUTES = 'buổi học kết thúc, chúc mừng lần sau.'

    exports.CLASS_END_TIP = 'sư phụ ra khỏi lớp.'

    exports.CLASS_ENDED = 'Đến giờ học rồi.'

    exports.TIME_BEFORE_CLASS_END = 'Còn ${time} giây nữa là hết giờ học'

    exports.CLASS_HAS_BEGAN_TIME = 'Lớp học đã bắt đầu ${hours} giờ ${minutes} phút ${seconds} giây'

    exports.WARNING_APPLY_SPEAK_STATUS_SWITCH_FREQUENT = 'xin đừng chuyển kênh thường xuyên'

    /**
     * =================================================
     * 设置主讲人
     * =================================================
     */

    exports.YOU_ARE_PRESENTER = 'anh được sắp xếp làm giáo viên chính'

    exports.YOU_ARE_NOT_PRESENTER = 'anh đã bị rút khỏi thẩm quyền của người giảng dạy.'

    exports.SET_USER_PRESENTER_TIP = 'Người trình bày đã chuyển sang ${username}'

    exports.CANCEL_USER_PRESENTER_TIP = 'Quyền giảng viên của người dùng ${username} đã bị thu hồi'

    exports.CANCEL_USER_PRESENTER_WHEN_OUT_TIP
        = 'Người dùng ${username} thoát khỏi lớp học và quyền giảng viên đã bị thu hồi'

    exports.OPEN_CAMERA_FAIL_TIP = 'lỗi bật máy ảnh'

    exports.OPEN_MIC_FAIL_TIP = 'lỗi bật microphone.'

    exports.PRESENTER_IN = 'giáo sư đã vào lớp'

    exports.PRESENTER_OUT = 'giáo sư đã rời khỏi lớp'

    exports.BJY_SUPPORT = 'bạch lí cung cấp dịch vụ truyền hình trực tiếp'

    exports.CONFIRM_SEND_PRIZE = 'anh có muốn gửi tin nhắn đỏ không?'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_CPU
        = 'phát hiện ra tốc độ sử dụng cpu của máy tính quá cao. xin hãy đóng phần mềm không liên quan đến phát sóng trực tiếp.'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_MEMORY
        = 'nó được phát hiện là tốc độ sử dụng của bộ nhớ máy tính quá cao. làm ơn đóng phần mềm không liên quan đến chương trình phát sóng trực tiếp.'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_BOTH
        = 'phát hiện ra tốc độ sử dụng của cpu và bộ nhớ quá cao. xin hãy đóng phần mềm không liên quan đến phát sóng trực tiếp.'

    exports.NETWORK_BAD_WARNING = 'hệ thống mạng rất yếu, âm thanh và video có thể bị kẹt.'

    exports.CHANGE_LINK_TYPE_DUE_TO_NETWORK = 'tình trạng mạng quá tệ, cố gắng chuyển qua một liên kết khác cho bạn.'

    exports.LABEL_WHITEBOARD_FILL = 'điền'

    exports.LABEL_WHITEBOARD_STROKE = 'Đá'

    exports.LABEL_FORBID_RAISE_HAND = 'không tay'

    exports.INFO_FORBID_RAISE_HAND = 'việc giơ tay đã bị cấm.'

    exports.INFO_UNFORBID_RAISE_HAND = 'cần phải giơ tay lên.'

    exports.INFO_FORBID_OPEN_MIC = 'tắt điện thoại'

    exports.INFO_UNFORBID_OPEN_MIC = 'micro đã bật'

    exports.INFO_TEACHER_FORBID_RAISE_HAND = 'việc giơ tay đã bị cấm.'

    exports.LABEL_GUEST = 'người dùng'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_NEW = 'tiếp tục ghi âm đám mây trước hay khởi động một đoạn mới?'

    exports.INFO_BUTTON_CONTINUE = 'tiếp tục ghi'

    exports.INFO_BUTTON_START_NEW = 'máy ghi âm mới'

    exports.LABEL_GUEST = 'người dùng'

    exports.SELECT_PROGRAM = 'hãy chọn một chương trình để chia sẻ'

    exports.CONFIRM_REMOVE_DOCUMENT_TRANSFORM_ING = 'tài liệu có mã hóa. bạn có chắc muốn xóa nó không?'

    exports.BUTTON_UPLOAD_PPT_DOCUMENT = 'tắt động tĩnh'

    exports.BUTTON_CHROME_FLASH_USER_GUIDE1_COMPLETE = 'thiết lập hoàn tất'

    exports.PRE_STEP = 'bước cuối'

    exports.NEXT_STEP = 'bước kế tiếp'

    exports.TIP_CHROME_FLASH_MORE_SETTING = 'phương pháp trên vẫn chưa giải quyết được vấn đề?'

    exports.VIEW_MORE_SETTING = 'xem thêm về thiết lập'

    exports.LABEL_NO_LONGER_REMIND = 'Đừng nhắc lại'

    exports.BUTTON_CLOSE = 'đóng'

    exports.CHROME_UPGRADE_INSTRUCTION
        = 'có một ngoại lệ trong máy chơi flash trong trình duyệt của bạn. hãy đặt chính xác theo phương pháp sau trước khi phát trực tiếp.'

    exports.CHROME_TIP_FLASH_SETTING_SET = '1. Đặt vùng nhận diện của hộp màu xanh trong hình vẽ bên dưới thành'

    exports.CHROME_TIP_FLASH_SETTING_ALLOW = 'luôn cho phép ở nơi này'

    exports.CHROME_TIP_FLASH_SETTING_THEN = 'và rồi'

    exports.CHROME_TIP_FLASH_SETTING_REFRESH = 'cập nhật'

    exports.CHROME_TIP_FLASH_SETTING_BROWSER = 'trình duyệt'

    exports.CHROME_TIP_FLASH_DOWNLOAD
        = '2. nếu trang này vẫn được hiển thị sau khi đặt, bạn cần tải xuống và cài đặt máy chơi flash mới nhất.'

    exports.DOWNLOAD_FLASH = 'tải về'

    exports.CHROME_MORE_SETTING_FLASH = 'xem thêm về thiết lập'

    /**
     * apple 帮助信息
     */
    exports.APPLE_HELP_INFO = 'gọi 8610-8545961 hoặc email tới yangdongliu@apple.com'

    exports.TIP_DO_NOT_SUPPORT_LOW_VERSION_IE = 'hệ thống duyệt của bạn quá thấp ~bọn t ôi không hỗ trợ phiên bản ie9!'

    exports.TIP_LOW_VERSION_IE_UPDATE_BROWSER = '1. xin hãy nâng cấp trình duyệt'

    exports.TIP_LOW_VERSION_IE_DOWNLOAD_CHROME = 'tải về'

    exports.TIP_LOW_VERSION_IE_CHANGE_MODE
        = '2. nếu bạn đang dùng 360, qq, soto và các bộ duyệt khác, xin chuyển qua chế độ tốc độ.'

    exports.TIP_LOW_VERSION_IE_CHANGE_BROWSER = '3. Đổi các trình duyệt khác'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_LIVE = 'sống trong đám mây'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_CLASSROOM = 'lớp cloud'

    exports.TIP_INVITATION_NAME_INPUT = 'hãy nhập nickname của bạn:'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE = 'hãy nhập số điện thoại:'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE_WRONG = 'hãy nhập số điện thoại di động đúng'

    exports.PLACEHOLDER_INVITATION_JOINCODE_INPUT = 'bạn có thể hỏi quản lý trực tiếp về mật mã tham gia.'

    exports.TIP_INVITATION_GET_JOINCODE = 'hãy nhập mật mã của bạn:'

    exports.TIP_INVITATION_NAME_SHOULD_NOT_BE_EMPTY = 'biệt danh không thể rỗng'

    exports.TIP_INVITATION_MOBILE_SHOULD_NOT_BE_EMPTY = 'số điện thoại di động không thể rỗng'

    exports.TIP_INVITATION_JOINCODE_SHOULD_NOT_BE_EMPTY = 'mật mã tham gia không thể rỗng'

    exports.TIP_INVITATION_JOINCODE_IS_NOT_RIGHT = 'hãy nhập mật mã bổ sung đúng.'

    exports.LOCAL_RECORD_PATH_NULL = 'hãy chọn đường dẫn lưu trữ video cục bộ'

    exports.INFO_LOCK_SCREEN = 'cửa khóa sinh viên mở'

    exports.INFO_UNLOCK_SCREEN = 'chưa ghi'

    exports.INFO_LOCK_SCREEN_STUDENT = 'thầy giáo đã mở khóa sinh viên, bây giờ bạn không thể vận hành phần mềm khác.'

    exports.LABEL_NERVER_PRINT = 'Đừng nhắc lại'

    exports.LABEL_LOCK_SCREEN_OPEN = 'mở'

    exports.INFO_LOCK_SCREEN_FIRST
        = 'sau khi mở khóa sinh viên, những học sinh dùng máy tính windows chỉ có thể dùng phần mềm này.'

    exports.INFO_COLLECT_SYSTEM_SOUND_FIRST
        = 'Để tránh nghe tiếng vang, khi bạn bật hệ thống mua âm thanh, bạn có thể giảm âm thanh của loa hoặc tắt loa.'

    exports.MEDIA_PLAYER_LOAD_FILE_FAILED
        = 'lỗi tải tập tin. hãy chắc chắn tập tin là một tập tin truyền thông hoặc mở một tập tin khác.'

    exports.CLASS_SWITCH_PARENT_TIP = 'nhập nhóm nhỏ'

    exports.CLASS_SWITCH_CHILD_TIP = 'nhập lớp lớn'

    exports.PARENT_CLASS_SWITCH_PARENT_TIP = 'hội thảo'

    exports.PARENT_CLASS_SWITCH_CHILD_TIP = 'họp lớp lớn'

    exports.CLASS_SWITCH_PARENT_SUCCESS_TIP = 'nó đã nhập vào một lớp lớn.'

    exports.CLASS_SWITCH_CHILD_SUCCESS_TIP = 'lớp nhỏ'

    exports.CLASS_SWITCH_ROOM_SERVER_WAITING = 'Đổi phòng, tái kết nối.'

    exports.CLASS_SWITCH_TIP = 'anh có chắc sẽ đổi lớp học chứ?'

    exports.CLASS_SWITCH_TIP_CLOUD_RECORD
        = '<div class="confirm-class-switch-tip">sau khi vào lớp lớn, đoạn ghi âm đám mây sẽ bị đình chỉ, và bạn cần quay lại lớp nhỏ để tạo ra phần mở nhạc.</div>'

    exports.CLASS_SWITCH_MEDIA_PLAYER_TIP = 'Đừng bật âm thanh và video địa phương trước.'

    exports.CLASS_SWITCH_THIRD_PUSH_TIP = 'xin dừng phát thứ ba trước.'

    exports.CLASS_SWITCH_SCREEN_SHAR_TIP = 'xin dừng chia sẻ màn hình trước'

    exports.CLASS_SWITCH_VIDEO_LAYOUT_TIP = 'xin dừng chuyển đổi bố trí video trước.'

    exports.CLASS_SWITCH_EXAM_TIP = 'xin dừng kiểm tra lớp trước.'

    exports.CLASSROOM_ENTER_COUNT_DOWN_LABEL = 'Đếm ngược:'

    /**
     * 图片添加至文档
     */
    exports.LABEL_IMAGE = 'ảnh'

    exports.LABEL_IMAGE_VIEW = 'xem thử'

    exports.LABEL_IMAGE_DOWNLOAD = 'tải về'

    exports.LABEL_ADD_TO_DOCUMENT = 'thêm vào các trường'

    exports.LABEL_OPEN_ON_BLACKBOARD = 'thêm và mở'

    exports.INFO_IMAGE_ADD_SUCCESS = 'bức ảnh đã được thêm vào khu vực tài liệu'

    exports.INFO_IMAGE_ADD_FAIL = 'Ảnh không được thêm thành công vào tài liệu'

    exports.WARING_IMAGE_HAS_ADDED = 'Ảnh đã được thêm vào tài liệu, xin đừng thêm nó lặp đi lặp lại.'

    exports.QRCODE_IMAGE_UPLOAD_DONE = 'Tải lên thành công, kết thúc sau ${countDown} giây ...'

    /**
     * 问答提示
     */
    exports.INFO_QUESTION_ANSWERED = 'sư phụ trả lời câu hỏi của anh, đi kiểm tra đi.'

    exports.CONFIRM_CLOSE_QUSETION_ANSWER = 'anh vẫn còn giữ nội dung chưa gửi đi, anh chắc sẽ đóng nó chứ?'

    /**
     * 浏览器不兼容提示
     */
    exports.BROWSER_NOT_SUPPORT_TIP_IE = 'phiên bản duyệt của bạn quá thấp, xin hãy nâng cấp thành ie10 hoặc trên.'

    exports.BROWSER_NOT_SUPPORT_TIP_WECHAT = 'wechat trình duyệt không hỗ trợ, hãy đến trình duyệt khác để mở.'

    exports.BROWSER_NOT_SUPPORT_TIP_WEBRTC
        = 'trình duyệt của bạn không hỗ trợ các khóa mạng. hãy sử dụng trình duyệt chrme mới nhất.'

    /**
     * 抽奖
     */

    exports.LOTTERY_STATUS_ING = 'trong xổ số, phần còn lại'

    exports.LOTTERY_COMMADN_ING_TIP
        = 'hiện tại, sổ xố vẫn đang được tiến hành. có muốn mở xổ số trước và thông báo danh sách trúng số không?'

    exports.LOTTERY_BUTTON_CONTINUE = 'tiếp tục vẽ'

    exports.LOTTERY_BUTTON_BEGIN_NOW = 'rút giải bây giờ.'

    exports.LOTTERY_BEGIN_IN_CHAT = 'nhập mật khẩu vào khu vực chat để tham gia vào xổ số'

    exports.LOTTERY_MESSAGE_TIP_BEFORE = 'nhập'

    exports.LOTTERY_MESSAGE_TIP_AFTER = 'tham gia rút thăm may mắn'

    /**
     * 音频设备统一切换
     */
    exports.COMBINED_AUDIO_DEVICE_SWITCH_CONFIRM = 'micro/ loa được tìm thấy trên cùng thiết bị, nó có bật không?'

    exports.COMBINED_AUDIO_DEVICE_SWITCH_OK = 'bật'

    /*
     * 授权画笔
     */
    exports.PAINT_AUTHORIZE_TIP_ENABLE = 'thầy giáo đã cho phép anh dùng chổi'

    exports.PAINT_AUTHORIZE_TIP_DISABLE = 'thầy giáo đã rút lại giấy phép'

    /*
     * 切换布局
     */
    exports.SWITCH_LAYOUT_METTING = 'chuyển sang bố trí phòng trưng bày'

    exports.SWITCH_LAYOUT_MONKEY = 'chuyển sang bố trí 3d'

    exports.CHECK_GRAYSCALE_FAIL
        = 'lỗi chuyển đổi môi trường. hãy liên lạc hỗ trợ kỹ thuật mây bạch lí để giải quyết vấn đề'

    exports.SWITCH_LAYOUT_SINGLE = 'chuyển sang bố trí video đơn lẻ'

    exports.DEVICE_IS_USING = 'thiết bị đã được sử dụng'

    exports.LINK_SHARE_SUCCESS = 'liên kết sao chép vào bảng nháp'

    exports.SHARE_LABEL_TITLE = 'chia màn hìnhname'

    exports.TEXT_NOTICE_LABEL_TITLE = 'thông báo ghi'

    exports.IMG_NOTICE_LABEL_TITLE = 'thông báo ảnh chụp'

    exports.USER_TAB_ALL = 'mọi thành viên'

    exports.USER_TAB_FORBID = 'cấm sử dụng'

    exports.USER_TAB_KICKOUT = 'người dùng bị đuổi.'

    exports.RECORD_COMPLETE_LIVE_TIP = 'Đã ghi lại khóa'

    exports.OPEN_RECORD_FILE = 'mở tập tin lưu hạng cục bộ'

    exports.HTTP_REQUEST_ERROR = 'yêu cầu mạng bị lỗi, xin kiểm tra mạng'

    /*
     * 权限控制
     */
    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_ENABLE = 'thầy giáo đã cho phép anh điều khiển tài liệu'

    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_DISABLE = 'thầy giáo đã rút quyền kiểm soát tài liệu của bạn'

    exports.AUTH_MANAGEMENT_LABEL_TITLE = 'quản lý quản lý'

    exports.TEXT_NO_SPEAK_AUTH = 'hiện t ại anh không được phép đi học lúa mì.'

    exports.TEXT_SPEAK_AUTH_NO = 'thầy giáo đã rút lại lời cho phép đi học lúa.'

    exports.TEXT_NO_NOTICE_AUTH = 'hiện t ại cô không có quyền công bố thông báo.'

    exports.TEXT_NOTICE_AUTH_NO = 'thầy giáo đã rút lại thông báo'

    exports.TEXT_NO_DOCUMENT_UPLOAD_AUTH = 'hiện t ại bạn không có quyền tải tài liệu lên'

    exports.TEXT_DOCUMENT_UPLOAD_AUTH_NO = 'thầy giáo đã rút lại giấy đăng tải.'

    exports.TEXT_NO_PAINTER_AUTH = 'hiện t ại anh không có phép cọ.'

    exports.TEXT_PAINTER_AUTH_NO = 'thầy giáo đã lấy lại sự đồng ý của con.'

    exports.TEXT_NO_CLASS_START_END_AUTH = 'hiện t ại cô không có quyền đi học hay rời khỏi lớp.'

    exports.TEXT_NO_CLOUD_RECORD_AUTH = 'bạn không có quyền ghi âm trong đám mây.'

    exports.NO_RECORD_AUTH
        = 'Để dùng chức năng ghi âm đám mây, bạn cần phải mở đám mây trên dòng sản phẩm yêu cầu trước. hãy liên lạc với tổ chức để mở nó!'

    exports.TEXT_NO_FORBID_AND_KICK_AUTH = 'anh không có quyền cấm và đá người ta ngay bây giờ.'

    exports.TEXT_NO_QUIZ_AUTH = 'Hiện tại bạn không có quyền công bố câu hỏi'

    exports.CONFIRM_RELOAD = 'cậu có chắc là muốn vào lại lớp học không?'

    exports.CONFIRM_CLOSE_ROOM
        = 'cậu có chắc là muốn dừng lớp học không?</br>sau khi đình chỉ mọi người dùng sẽ bị đuổi khỏi lớp học và lớp học sẽ bị đóng cửa và không thể vào lớp'

    exports.EXTENSION_LABEL_TITLE = 'bộ trợ lý chia sẻ màn hình'

    exports.FORBID_LIVE = 'ngừng phát sóng'

    exports.AUTO_PLAY_TITLE = 'bước '

    exports.SCREEN_SHARE_ERROR = 'lỗi chia màn hình, xin nhắc lại và thử lại'

    exports.PUBLISH_ERROR = 'lỗi xuất video, xin nhắc lại và thử lại'

    exports.SUBSCRIBE_ERROR = 'lỗi tải video, xin lỗi tải lại và thử lại'

    exports.WEBRTC_SERVER_CONNECT_TIMEOUT = 'thời gian kết nối máy chủ video, xin nhớ lại và thử lại'

    exports.CAN_NOT_SCREEN_SHARE_WHEN_CLASS_END = 'không thể chia sẻ màn hình'

    exports.PPT_VIDEO_SWITCH_CONTENT_TIP = 'thay đổi vị trí của cửa sổ video và bảng trắng.'

    exports.PPT_VIDEO_SWITCH_LOCAL = 'chỉ công tắc cục bộ'

    exports.PPT_VIDEO_SWITCH_ALL = 'bộ chuyển đổi'

    exports.CLASS_HISTORY_BACK_TIP = 'quay'

    exports.HISTORY_BACK_ALERT_TIP = 'Có nên rời khỏi phòng trực tiếp hay không?'

    exports.RESULT_SCOPE_JINGXI = 'tiền vàng'

    exports.TIP_ROOM_SERVER_LOGIN_KICKED_OUT = 'bạn đã bị đuổi khỏi lớp học và không thể đổi lớp học'

    exports.LOTTERY_TIME_STOP = 'dừng vẽ'

    exports.LOTTERY_TIME_STOP_TIP = 'anh chắc chắn dừng xổ số chứ?'

    exports.TEXT_LOTTERY_SUCCESS = 'bạn đã tham gia vào trận đấu may mắn.'

    exports.TEXT_LOTTERY_COMMAND_FAIL = 'lỗi nhập mật khẩu, xin nhập lại'

    exports.TEXT_LOTTERY_CLOSE_NO_SUBMIT = 'anh chưa gửi thông tin, anh chắc sẽ đóng cửa chứ?'

    exports.TEXT_LOTTERY_TEACHER_OPENED = 'cuộc cùng đã bắt đầu'

    exports.TEXT_VOTE_TEACHER_OPENED = 'Đang bỏ phiếu'

    exports.TEXT_TEACHER_TITLE = 'khởi động bỏ phiếu'

    exports.CLASS_STATUS_STOP_WARMING_UP = 'Đừng nóng lên nữa.'

    exports.TEXT_DETELE_WHITEBOARD = 'xoá bỏ bảng trắng hiện thời và nội dung của nó?'

    exports.INFO_PLAYER_LOW_UPLINK_AUDIO_BANDWIDTH
        = 'hệ thống phát hiện micro của anh không hoạt động đúng. xin hãy kết nối lại thiết bị.'

    exports.INFO_RED_PACKET_CREATE_FAIL = 'lỗi tạo phong bì đỏ'

    exports.CLEAR_ALL_SHAPE_TIP
        = '<p><icon>không!</icon>anh có chắc là muốn xóa hết không?</p><p>hoạt động này sẽ xóa toàn bộ nội dung sửa chữa và chú thích, và không thể phục hồi.làm ơn hành động cẩn thận!<p>'

    exports.CLEAR_ALL_SHAPE_OK_TIP = 'dọn dẹp đi.'

    exports.CAN_NOT_PUSH_WEBRTC_STREAM
        = 'máy duyệt hiện thời không hỗ trợ mac, xin hãy dùng loại crom mới nhất hoặc khách hàng'

    exports.TEXT_FORBID_CLASS_START_END = 'không phải lúc học hết lớp đâu.'

    exports.CONFIRM_EXIT_CLASSROOM_FORBID_END_CLASS = 'bây giờ không phải hết giờ học, cậu vẫn muốn nghỉ à?'

    exports.CONFIRM_LOCATE_PREV_PAGE_END_CLASS
        = 'trở lại trang trước sẽ tự động kết thúc lớp. bạn có muốn quay lại không?'

    exports.CONFIRM_LOCATE_PREV_PAGE_EXIT_CLASSROOM
        = 'trở về trang trước sẽ thoát khỏi lớp học ngay lập tức. bạn có muốn quay lại không?'

    exports.BUTTON_SWITCH_MIX_MAIN_USER = 'chuyển đổi kế hoạch'

    exports.TITLE_SIWTCH_MIX_MAIN_USER = 'sau khi tắt, màn hình video mà sinh viên xem sẽ được hiển thị đồng bộ.'

    exports.MIX_USER_SCREEN_CHANGE_TIP = '${userName} đã được chuyển sang màn hình chính'

    exports.LOTTERY_HISTORY_LIST = 'thành tích thành đạt'

    /**
     * 低版本 app 不支持作业功能提示
     */
    exports.ALERT_TITLE = 'mẹo'

    exports.ALERT_FIND_LOW_VERSION_APP_IN_CLASS_NOT_SUPPORT_HOMEWORK = 'máy cuối di động không hỗ trợ chức năng này.'

    exports.TIP_I_KONW = 'Được rồi!'

    exports.BUTTON_AUTHORIZE_H5_PPT = 'những dòng h5 được phê chuẩn'

    exports.BUTTON_AUTHORIZE_H5_PPT_OFF = 'hủy lệnh'

    exports.TIP_AUTHORIZE_H5_PPT_ON = 'tất cả các tập luyện h5'

    exports.TIP_AUTHORIZE_H5_PPT_OFF = 'dự án h5 bị hủy bỏ'

    exports.WEBRTC_TYPE_CHANGE_TIP = 'phòng này đã đổi đường dây, sẽ vào lại phòng, xin chờ.'

    exports.TIP_DISABLE_CONTROLL_FORBID_ALL = 'thầy giáo đã mở hết mọi điều cấm.'

    exports.TIP_NOT_ALLOW_AUTHORIZE_H5_PPT = 'Bạn đã cấm học sinh quay trang và không thể cho phép các lớp học'

    exports.TIP_CANCEL_AUTHORIZE_H5_PPT = 'Anh không cho học sinh quay trang, và giấy phép chữa học đã bị hủy bỏ'

    /**
     * safari flv 拉流提示
     */
    exports.LABEL_SAFARI_FLV_PULL_TIPS
        = 'không thể có âm thanh và video trực tiếp?mở "thiết lập này..." trong trình duyệt safari và đặt tự động để "cho phép mọi tự động chơi".'

    /**
     * =================================================
     * 外接手机摄像头
     * =================================================
     */
    exports.DIALOG_TITLE_PHONE_CAMERA_QRCODE = 'máy quét video trực tiếp'

    exports.TIP_USE_PHONE_CAMERA_QRCODE = 'hãy sử dụng ứng dụng lớp mây để quét trực tiếp mã'

    exports.DIALOG_TITLE_STOP_PHONE_CAMERA = 'kết thúc phát trực tiếp các thiết bị ngoài'

    exports.TIP_OPEN_MAIN_CAMERA = 'bật máy ảnh thiết bị chính lên'

    /**
     * 屏幕共享音源选择
     */
    exports.SCREEN_SHARE_AUDIO_SELECT_TITLE = 'chọn một nguồn âm thanh'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC = 'Âm thanh chia sẻ'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC_TIPS = 'học sinh sẽ nghe thấy microphone của bạn khi màn hình được chia sẻ.'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM = 'Âm thanh chung'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_1
        = 'học sinh sẽ nghe thấy giọng nói của bạn khi màn hình được chia sẻ'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_2 = '(v. d. nhắc lời nhắn nhanh, âm nhạc, đoạn video, v.v.)'

    /**
     * =================================================
     * 美颜
     * =================================================
     */
    exports.DIALOG_TITLE_CLIP_IMAGE = 'ảnh'

    exports.TIP_INIT_BEAUTY_FAIL = 'khởi tạo chương trình sắc thất bại'

    exports.SETTING_LABEL_BEAUTY = 'lọc sắc'

    exports.SETTING_LABEL_VIRTUAL_BG = 'nền ảo'

    exports.SETTING_TIP_WEB_BEAUTY
        = 'Bộ lọc làm đẹp <br/>1, vẻ đẹp mở, lấy một bộ nhớ và cpu nhất định; <br/>2, để tránh bạn trong trang web, vui lòng bật tăng tốc phần cứng; <br/>3. Nếu bạn cần thêm vẻ đẹp và nền ảo, hiệu ứng nâng cao, vui lòng đi đến Nền và sử dụng nó trên máy khách!'

    /**
     * =================================================
     * 选择显身 / 隐身
     * =================================================
     */
    exports.LABEL_ASSISTANT_VISIBLE_TIPS = 'nếu bạn là trợ lý dạy lớp học, hãy sử dụng danh tính cá nhân để vào trong.'

    exports.LABEL_ASSISTANT_HIDDEN_TIPS
        = 'nếu bạn là giám sát lớp học hay trợ lý tham quan, hãy sử dụng danh tính vô hình để xâm nhập. không ai khác có thể thấy bạn.'

    exports.LABEL_ASSISTANT_ENTER = 'vào trong'

    /**
     * =================================================
     * 摄像机采集模式切换
     * =================================================
     */
    exports.HINT_CLIENT_VIDEO_CAPTURE_MODE_CHANGE_DIALOG_TEXT
        = 'thiết lập chế độ giành được máy ảnh sẽ có tác dụng sau khi khởi động lại phần mềm. giờ khởi động lại phần mềm?'

    /**
     * =================================================
     * 积分
     * =================================================
     */
    exports.BONUS_BUBBLE_TIP = 'name'

    exports.BONUS_MY_POINTS = 'Điểm của tôi'

    exports.BONUS_POINTS_RANK = 'cấp độ các điểm'

    exports.BONUS_POINTS_NOT_ENOUNGH
        = 'chỉ điểm chưa đủ cho chiến dịch này, sẽ không có điểm nào được phát hành tạm thời.'

    /**
     * =================================================
     * 智写云笔手写板
     * =================================================
     */
    exports.TIP_HAND_WRITTING_BOARD_CONNECTED = 'kết nối tốt'

    exports.TIP_HAND_WRITTING_BOARD_DISCONNECTED = 'kết nối'

    exports.TIP_HAND_WRITTING_BOARD_SLEEP
        = 'phiến đá đang ngủ đông. xin hãy nhấn nút nguồn trên phiến đá bên ngoài để đánh thức thiết bị.'

    exports.CONFIRM_TITLE_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = 'cần nhắc hệ thống'

    exports.CONFIRM_CONTENT_HAND_WRITTING_BOARD_BEFORE_DISCONNECT
        = 'bạn có muốn ngắt kết nối từ máy tính bên ngoài không?'

    exports.CANVAS_SWITCH_TO_WHITEBOARD = 'chuyển sang bảng trắng'

    exports.CANVAS_SWITCH_TO_DOCUMENT = 'Chuyển sang phần mềm học liệu: ${name}'

    /**
     * =================================================
     * 抢答器
     * =================================================
     */

    exports.TIP_USER_OFFLINE = 'học sinh không có trong lớp'

    exports.TIP_USER_ON_STAGE_ALREADY = 'học sinh đã được trồng lúa mì.'

    exports.TIP_NOT_ALLOW_SPEAK = 'Truyền hình trực tiếp không hỗ trợ'

    /**
     * =================================================
     * 检测录制
     * =================================================
     */
    exports.TIP_RECORD_SOFTWARE_CHECKED
        = 'Chương trình phát hiện rằng bạn đang ghi âm màn hình. Vui lòng đóng phần mềm ghi âm màn hình và khởi động lại khách hàng để xem.'

    /**
     * =================================================
     * 转播
     * =================================================
     */
    exports.INFO_CAN_NOT_OPERATE_MEDIA_WHEN_TRANSFER_CLASS
        = 'Các thao tác này không thể thao tác và quản lý các thao tác âm thanh khi tiến hành'

    exports.CONFIRM_END_TRANSFER_CLASS = 'Đài phát thanh đang được phát sóng.'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_TRANSFER_CLASS_END
        = 'Hàng phương tiện không thể sử dụng trước khi buổi phát sóng kết thúc.'

    exports.INFO_CAN_NOT_START_TRANSFER_CLASS_BEFORE_START_CLASS
        = 'Hướng dẫn không bắt đầu và không thể phát sóng được.'

    exports.CAN_NOT_STOP_RTMP_PUSH_WHEN_TRANSFER_CLASS_BEGIN = 'Chức năng phát sóng không thể bị cấm'

    exports.COMMON_ERROR_PAGE_TIP_PREFIX = ''

    /**
     * =================================================
     * 打开摄像头提示
     * =================================================
     */
    exports.INFO_IF_OPEN_CAMERA = 'Bật máy ảnh?'

    exports.BUTTON_NOT_OPEN_CAMERA = 'Đừng mở'

    exports.BUTTON_OPEN_CAMERA = 'mở'

    /**
     * =================================================
     * 字幕
     * =================================================
     */
    exports.BUTTON_CAPTION = 'Tựa:'

    exports.BUTTON_CLOSE_CAPTION = 'Đóng phụ đề'

    /**
     * =================================================
     * 福袋
     * =================================================
     */
    exports.TIP_END_LUCKY_BAG = 'Nếu túi phù hộ dừng lại, nó không thể phục hồi được.'

    /**
     * =================================================
     * PK 功能
     * =================================================
     */
    exports.TIP_PK_USER_NOT_ENOUGH = 'Nhưng số phát ngôn không đủ'

    exports.TIP_PK_USER_OUT = 'Đã ra khỏi lớp, xin hãy khởi động lại thành viên PK'

    /**
     * =================================================
     * 打开网页
     * =================================================
     */
    exports.TIP_CLOSE_WEB_PAGE = 'Đóng cửa sổ sẽ lấy lại trang học sinh. bạn có muốn tiếp tục không?'

    exports.TIP_PAGE_CANCEL = 'trang đã bị đóng'

    exports.MANAGE_EXPLORER = 'Trình duyệt'

    exports.ELECTRON_CLIENT_AVSDK_CAN_NOT_PUSH_STREAM_TIP = 'Phiên bản Electron không hỗ trợ đẩy video âm thanh hiện tại, vui lòng tải xuống phiên bản CEF trên trang web chính thức!'

    /**
     * =================================================
     * 白板导出
     * =================================================
     */
    exports.BLACKBOARD_EXPORT = 'Lưu bảng'

    /**
     * =================================================
     * 自定义推流布局
     * =================================================
     */
    exports.VIDEO_LAYOUT_SETTING = 'Tùy chỉnh Push Flow Layout'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_VIDEO_LAYOUT = 'Bạn không thể sử dụng Media Play trước khi tắt bố cục Push Stream tùy chỉnh'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_VIDEO_LAYOUT = 'Bạn không thể sử dụng chia sẻ màn hình trước khi tắt bố cục push stream tùy chỉnh'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_SCREEN_SHARE = 'Bạn không thể sử dụng bố cục đẩy tùy chỉnh trước khi tắt chia sẻ màn hình'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_MEDIA_FILE = 'Bạn không thể sử dụng bố cục đẩy tùy chỉnh trước khi tắt video'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_PLAYBACK = 'Không thể sử dụng bố cục đẩy tùy chỉnh trước khi tắt phát lại'

    exports.INFO_PUBLISH_VIDEO_LAYOUT_SHOULD_BE_PRESENTER = 'Chỉ có diễn giả chính mới có thể sử dụng bố cục đẩy tùy chỉnh'

    /**
     * =================================================
     * 切换 WebRTC 节点
     * =================================================
     */
    exports.BUTTON_SWITCH_WEBRTC_NODE = 'Chuyển đổi nút WebRTC'

    exports.INFO_CAN_NOT_SWITCH_WEBRTC_NODE_IN_WEBRTC_MIX = 'Không thể chuyển đổi nút WebRTC trong chế độ trộn WebRTC'

    /**
     * =================================================
     * 本地录制提示
     * =================================================
     */
    exports.INFO_CONFIRM_STOP_LOCAL_RECORD = 'Trong ghi âm địa phương, bạn có chắc chắn muốn dừng ghi âm địa phương?'

    exports.INFO_LOCAL_RECORD_GENERATE = 'Trong quá trình quay video cục bộ, không thể rời khỏi phòng truyền hình trực tiếp.'

    exports.INFO_LOCAL_RECORD_HAS_GENERATE = 'Video được ghi lại cục bộ đã được tạo.'

    /**
     * =================================================
     *  推荐卡片
     * =================================================
     */
    exports.TITLE_RECOMMEND_CARD = 'Thẻ giới thiệu'

    /**
     * =================================================
     *  申请开麦
     * =================================================
     */
    exports.MIC_APPLY_DESC = 'Học sinh đã yêu cầu mở micro, bạn có muốn mở không?'
    
    exports.MIC_REJECT_TIP = 'Học sinh đã bị từ chối mở micro'

    exports.MIC_ACCEPT_TIP = 'Học sinh đã được mở micro'

    exports.TIP_ON_WALL = 'Chúc mừng bài viết đã được chọn để đặt trên bảng'

    /**
     * =================================================
     *  cpu 提示
     * =================================================
     */
    exports.TIP_CPU_HIGH_LIMIT_SCREEN_SHARE = "Hệ thống phát hiện CPU hiện tại vượt quá 70%, sử dụng 'Chia sẻ màn hình' sẽ dẫn đến phát trực tiếp bất thường, không hỗ trợ bật!"

    exports.TIP_CPU_HIGH_LIMIT_BEAUTY = "Hệ thống phát hiện CPU hiện tại vượt quá 70%, bật 'Beauty/Virtual Background' sẽ dẫn đến phát sóng trực tiếp bất thường, không hỗ trợ bật!"

    exports.TIP_CPU_HIGH_END_SCREEN_SHARE = "Hệ thống phát hiện CPU hiện tại hơn 80% và việc sử dụng 'Chia sẻ màn hình' gây ra bất thường phát trực tiếp đã làm gián đoạn việc chia sẻ cho bạn!"

    exports.TIP_CPU_HIGH_END_BEAUTY = "Hệ thống phát hiện CPU hiện tại hơn 80% và tiếp tục sử dụng 'Beauty/Virtual Background' sẽ gây ra bất thường phát trực tiếp đã được tắt cho bạn!"
})
